import React, { Component } from "react";
import {Card, Form, Button, Row, Col, Alert, Tab, Tabs, Modal, Table} from "react-bootstrap";
import { IMaskInput } from "react-imask";
import api from "../../services/api";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { formataDataApi, formataDataExibicao, formataCNPJ, formataCPF, getCurrentUser, hasPerm, tiposSessoesAtendExtra, calcularIdade, formataDataHoraExibicao} from '../../common/utils';
import { withRouter } from '../../common/with-router';
import AsyncSelect from 'react-select/async';
import axios from 'axios';
import { FaCheck, FaTimes, FaStream, FaEye, FaRegEdit } from "react-icons/fa";
import { getConfig } from "../../common/config";
import PacienteAcesso from "./PacienteAcesso";

function programaPermiteLoginBeneficiario(programaDados) {
    const configuracoes = programaDados?.configuracoes;

    if (!configuracoes || typeof configuracoes !== 'object') {
        return false;
    }

    if (configuracoes.permite_login_beneficiario === true) {
        return true;
    }

    const beneficiarioCfg = configuracoes.beneficiario;
    if (beneficiarioCfg && typeof beneficiarioCfg === 'object' && beneficiarioCfg.permite_login_beneficiario === true) {
        return true;
    }

    return false;
}

function todayISO() {
  return new Date().toISOString().slice(0, 10); // YYYY-MM-DD
}

function getDateLimits(mascara = '') {
  let min = null, max = null;
  if (/\bno-past\b/i.test(mascara)) min = todayISO();
  const mMin = mascara.match(/date-min\[(today|\d{4}-\d{2}-\d{2})\]/i);
  const mMax = mascara.match(/date-max\[(today|\d{4}-\d{2}-\d{2})\]/i);
  const resolve = (v) => (String(v).toLowerCase() === 'today' ? todayISO() : v);
  if (mMin) min = resolve(mMin[1]);
  if (mMax) max = resolve(mMax[1]);
  return { min, max };
}

// clamp para quem digita manualmente
function clampDate(val, { min, max }) {
  let v = val || '';
  if (min && v < min) v = min;
  if (max && v > max) v = max;
  return v;
}

function getAllowedWeekdays(mascara = '') {
  if (/\ballow-mon-thu\b/i.test(mascara)) return new Set([1,2,3,4]); // seg..qui
  const m = mascara.match(/allow-weekdays\[(.*?)\]/i);
  if (m) {
    const days = m[1].split(',').map(s => parseInt(s.trim(), 10)).filter(n => n>=0 && n<=6);
    return new Set(days);
  }
  return null;
}

function isAllowedDateByWeekday(dateStr, allowedSet) {
  if (!allowedSet || !dateStr) return true;
  const d = new Date(`${dateStr}T00:00:00`);
  if (Number.isNaN(d.getTime())) return true;
  return allowedSet.has(d.getDay()); // 0=Dom ... 6=Sáb
}

class PacientesEdit extends Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.onChangeCep = this.onChangeCep.bind(this);
        this.enviaPaciente = this.enviaPaciente.bind(this);
        this.handlePasteCep = this.handlePasteCep.bind(this);
        this.handlePaste = this.handlePaste.bind(this);

        this.fileInput = React.createRef();

        this.list_generos = {
            "F": "Feminino",
            "M": "Masculino"
        };

        this.state = {
            cpf: '',
            nome: "",
            data_nascimento: "",
            email: "",
            telefone: "",
            celular: "",
            genero: "NI",
            cep: '',
            nome_local: '',
            endereco: '',
            numero: '',
            complemento: '',
            bairro: '',
            cidade: '',
            uf: '',
            endereco_telefone: "",
            plano_saude: '',
            numero_carteirinha: '',
            cliente_id: this.props.dados_cliente?.cliente_id || '',
            cliente_nome: this.props.dados_cliente?.cliente_nome || '',
            plano_id: '',
            plano_nome: '',
            tipo_cuidador: '',
            cuidador_nome: '',
            cuidador_cpf: '',
            cuidador_data_nascimento: '',
            cuidador_endereco: '',
            cuidador_celular: '',
            cuidador_telefone: '',
            cuidador_email: '',
            programa_dados: this.props.dados_programa || [],
            confirmacao_diagnostico: false,
            nomeLocalHelper: "",
            nomeHelper: "",
            dataNascimentoHelper: "",
            cpfHelper: "",
            emailHelper: "",
            telefoneHelper: "",
            enderecoTelefoneHelper: "",
            celularHelper: "",
            cepHelper: '',
            enderecoHelper: '',
            numeroHelper: '',
            complementoHelper: '',
            bairroHelper: '',
            cidadeHelper: '',
            ufHelper: '',
            planoIdHelper: '',
            tipoCuidadorHelper: '',
            cuidadorNomeHelper: "",
            cuidadorCpfHelper: "",
            cuidadorDataNascimentoHelper: "",
            cuidadorEnderecoHelper: "",
            cuidadorCelularHelper: "",
            cuidadorTelefoneHelper: "",
            cuidadorEmailHelper: "",
            clienteIdHelper: '',
            erroLoadPaciente: "",
            paciente_id: "",
            titulo_pagina: "",
            loading: false,
            vinculo_cuidador: false,
            programa_id: this.props.dados_programa?.programa_id || '',
            programa_nome: this.props.dados_programa?.programa_nome || '',
            medico_id: this.props.medico_id || '',
            doenca_id: this.props.doenca_id || '',
            doenca_nome: this.props.doenca_nome || '',
            doenca_idade_minima: this.props.doenca_idade_minima || '',
            doenca_idade_maxima: this.props.doenca_idade_maxima || '',
            exige_cpf_atendimento: this.props.dados_programa ? this.props.dados_programa.exige_cpf_atendimento : false,
            doencas: [],
            medicos: [],
            valoresCamposExtraPaciente: {},
            novoEndereco: {
                cep: '',
                endereco: '',
                numero: '',
                complemento: '',
                bairro: '',
                cidade: '',
                uf: '',
            },
            loadingEnderecoExtra: false,
            enderecoExtraSalvo: false,
            centrosReferencia: [],
            loadingCentrosReferencia: false,
            enderecoKitOpcao: 'outro',
            pacientes_campos: [],
            extra_valores_list: [],
            campo_historico: [],
            cadastro_teste: false,
            cpf_nao_informado: false,
            aceita_receber_whatsapp: false,
            aceita_receber_emails: false,
            aceita_receber_ligacoes: false,
            historicoCampoAtual: null,  
            showHistoricoModal: false,
            cuidador_documento_file: null,     // File recém-selecionado
            cuidador_documento_url: "",        // URL já salva no backend (se houver)
            cuidadorDocumentoHelper: "",       // helper p/ erros de validação
            alertasExibidos: new Set(),
        };

        this.list_sexos = {"F": "Feminino", "M": "Masculino", "O": "Outro"};

        this.list_tipos_cuidadores = {
            "pais": "Pais",
            //"conjuge": "Cônjuge",
            //"filho": "Filho",
            "parente": "Parente",
            "outro": "Outro",
        }  

        this.list_tipos_pessoa = {"fisica": "Física", "juridica": "Jurídica"};

        this.ufOptions = {
            "AC": "Acre",
            "AL": "Alagoas",
            "AP": "Amapá",
            "AM": "Amazonas",
            "BA": "Bahia",
            "CE": "Ceará",
            "DF": "Distrito Federal",
            "ES": "Espírito Santo",
            "GO": "Goiás",
            "MA": "Maranhão",
            "MT": "Mato Grosso",
            "MS": "Mato Grosso do Sul",
            "MG": "Minas Gerais",
            "PA": "Pará",
            "PB": "Paraíba",
            "PR": "Paraná",
            "PE": "Pernambuco",
            "PI": "Piauí",
            "RJ": "Rio de Janeiro",
            "RN": "Rio Grande do Norte",
            "RS": "Rio Grande do Sul",
            "RO": "Rondônia",
            "RR": "Roraima",
            "SC": "Santa Catarina",
            "SP": "São Paulo",
            "SE": "Sergipe",
            "TO": "Tocantins"
        };

    }

    componentDidMount(){

        console.log("Dados do programa");
        console.log(this.state.programa_dados);

        let id = '';
        let cliente_id = '';
        let dados_usuario = getCurrentUser();
        cliente_id = (dados_usuario['ambiente_cliente_id']) ? dados_usuario['ambiente_cliente_id'] : this.state.cliente_id;

        if (this.props.onAtualizar){
            id = this.props.id;
            cliente_id = !cliente_id ? this.props.cliente_id : cliente_id;
        }
        else {
            cliente_id = !cliente_id ? new URLSearchParams(this.props.router.location.search).get("cliente_id") : cliente_id;
            id = this.props.router.params.id;
        }

        if (cliente_id){
            this.setState({
                cliente_id: cliente_id
            });
        }

        if(id){
            this.setState({
                paciente_id: id,
                titulo_pagina: 'Editando Paciente',
                loading: true,
                erroLoadPaciente: ''
            })

            //consulta os dados do paciente na api
            api.get(`/pessoas/beneficiarios/${id}/?cliente_id=${cliente_id}`)
            .then(response => {
                const dadosResponse = response.data;

                const dados = this.tratarNulos(dadosResponse);

                //preenche os inputs
                this.setState({
                    erroLoadPaciente: '',
                    nome: dados.nome,
                    data_nascimento: dados.data_nascimento,
                    cpf: dados.cpf,
                    email: dados.email,
                    telefone: dados.telefone,
                    endereco_telefone: dados.endereco_telefone,
                    celular: dados.celular,
                    genero: dados.genero,
                    cep: dados.cep,
                    nome_local: dados.nome_local,
                    endereco: dados.endereco,
                    numero: dados.numero,
                    complemento: dados.complemento,
                    bairro: dados.bairro,
                    cidade: dados.cidade,
                    uf: dados.uf,
                    cadastro_teste: dados.cadastro_teste,
                    plano_saude: dados.plano_saude,
                    numero_carteirinha: dados.numero_carteirinha,
                    cliente_id: dados.cliente_id,
                    cliente_nome: dados.dados_cliente.nome,
                    plano_id: dados.plano_id,
                    plano_nome: dados.dados_plano.nome,
                    vinculo_cuidador: dados.vinculo_cuidador,
                    tipo_cuidador: dados.tipo_cuidador,
                    cuidador_nome: dados.cuidador_nome,
                    cuidador_cpf: dados.cuidador_cpf,
                    cuidador_data_nascimento: dados.cuidador_data_nascimento,
                    cuidador_endereco: dados.cuidador_endereco,
                    cuidador_celular: dados.cuidador_celular,
                    cuidador_telefone: dados.cuidador_telefone,
                    cuidador_email: dados.cuidador_email,
                    programa_id: dados.programa_id,
                    programa_nome: dados.dados_programa.nome,
                    exige_cpf_atendimento: dados.dados_programa.exige_cpf_atendimento,

                    extra_valores_list: dados.extra_valores_list,
                    aceita_receber_emails: dados.aceita_receber_emails,
                    aceita_receber_ligacoes: dados.aceita_receber_ligacoes,
                    aceita_receber_whatsapp: dados.aceita_receber_whatsapp,
                    confirmacao_diagnostico: true,
                    loading: false,
                    cuidador_documento_url: dados.cuidador_documento || "",
                }, () => {
                    if(!dados.cpf && !dados.dados_programa.exige_cpf_atendimento) {
                        this.setState({
                            cpf_nao_informado: true
                        });
                    }
                    this.carregarDoencasPaciente();
                    this.carregarMedicosPaciente();
                    this.carregaCamposExtraPaciente();
                    this.carregaDadosPrograma();
                    this.carregarEnderecoExtra();
                    this.carregarCentrosReferencia();
                });
                //this.carregarClientePaciente();
                //this.carregarPlanoPaciente();

                

            })
            .catch(error => {
                let erro_msg = 'Erro ao consultar paciente, tente novamente';

                if(error.response && error.response.status === 500){
                    erro_msg = 'Servidor indisponível no momento, tente novamente';
                }

                this.setState({
                    erroLoadPaciente: erro_msg,
                })
            });
        }
        else {
            this.setState({
                paciente_id: '',
                titulo_pagina: 'Adicionar Paciente',
                loading: false,
                erroLoadPaciente: '',
            });
            this.carregaCamposExtraPaciente(); 
            this.carregaDadosPrograma();

            if (this.state.medico_id) {
                this.carregarCentrosReferencia();
            }
        }

       
    }

    componentDidUpdate(prevProps, prevState) {
        const vcChanged  = prevState.valoresCamposExtraPaciente !== this.state.valoresCamposExtraPaciente;
        const pcChanged  = prevState.pacientes_campos             !== this.state.pacientes_campos;
        const evlChanged = prevState.extra_valores_list           !== this.state.extra_valores_list;

        if (vcChanged || pcChanged || evlChanged) {
            this.maybeRecalculateDerivedFields();
            this.verificarAlertasCondicionais(prevState);
        }
    }

    carregaDadosPrograma = () => {
        let dados_usuario = getCurrentUser();
        const programa_id = (dados_usuario['ambiente_programa_id']) ? dados_usuario['ambiente_programa_id'] : this.state.programa_id;
        if (programa_id) {
            api.get(`/programas/${programa_id}/`)
                .then(response => {
                    let programa_dados = { ...response.data };

                    // ✅ se houver this.state.paciente_id, força endereco_paciente_obrigatorio = true
                    if (this.state.paciente_id) {
                        programa_dados.endereco_paciente_obrigatorio = true;
                    }

                    this.setState({ 
                        programa_dados,
                        programa_id,
                        exige_cpf_atendimento: programa_dados?.exige_cpf_atendimento
                    });
                })
                .catch(error => {
                    console.error('Erro ao carregar dados do programa atual:', error);
                    
                    let erro_msg = 'Erro ao carregar dados do programa, tente novamente';

                    if(error.response && error.response.status === 500){
                        erro_msg = 'Servidor indisponível no momento, tente novamente';
                    }

                    this.setState({
                        erroLoadRegistro: erro_msg,
                    })
                });
        }
    };

    carregarClientes = async (inputValue) => {
        try {
            const response = await api.get(`/pessoas/clientes/?nome=${inputValue}`);
            const opcoes = response.data.results.map(cliente => ({
                value: cliente.id,
                label: cliente.dados_pessoa.nome_fantasia ? `${cliente.dados_pessoa.nome_fantasia} (${cliente.dados_pessoa.razao_social})` : cliente.dados_pessoa.nome
            }));
            //this.setState({ opcoesClientes: opcoes });

            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar clientes:', error);
            return [];
        }
    };

    carregarPlanos = async (inputValue) => {
        if (inputValue.length < 3) return [];
        try {
            const response = await api.get(`/planos/?nome=${inputValue}`);
            const opcoes = response.data.results.map(plano => ({
                value: plano.id,
                label: plano.nome
            }));
            //this.setState({ opcoesClientes: opcoes });
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar clientes:', error);
            return [];
        }
    };

    carregarClientePaciente = async () => {
        if(this.state.cliente_id) {
            api.get(`/pessoas/clientes/${this.state.cliente_id}/`)
            .then(response => {
                const dados = response.data;

                //preenche os inputs
                this.setState({
                    cliente_nome: (dados.dados_pessoa.razao_social) ? `${dados.dados_pessoa.nome_fantasia} (${dados.dados_pessoa.razao_social})` : dados.dados_pessoa.nome_fantasia
                });

            })
            .catch(error => {
                let erro_msg = 'Erro ao consultar cliente do paciente, tente novamente';

                if(error.response && error.response.status === 500){
                    erro_msg = 'Servidor indisponível no momento, tente novamente';
                }
                console.log(erro_msg);
            });
        }
    };

    carregarPlanoPaciente = async () => {
        if(this.state.plano_id) {
            api.get(`/planos/${this.state.plano_id}/`)
            .then(response => {
                const dados = response.data;

                //preenche os inputs
                this.setState({
                    plano_nome: dados.nome
                });

            })
            .catch(error => {
                let erro_msg = 'Erro ao consultar plano do paciente, tente novamente';

                if(error.response && error.response.status === 500){
                    erro_msg = 'Servidor indisponível no momento, tente novamente';
                }
                console.log(erro_msg);
            });
        }
    };

    verificarCpfExistente = async (cpf) => {
        try {
            const response = await api.get(`/pessoas/beneficiarios/?programa_id=${this.state.programa_id}&cpf=${cpf}`);
            if (response.data && response.data.results && response.data.results.length > 0) {
                return response.data.results[0];
            }
            return null;
        } catch (error) {
            console.error('Erro ao verificar CPF existente:', error);
            return null;
        }
    };

    handleCpfChange = async (value) => {
        this.setState({ cpf: value });

        const cpfLimpo = value.replace(/\D/g, '');

        if (cpfLimpo.length === 11) {
            const pacienteExistente = await this.verificarCpfExistente(cpfLimpo);

            if (pacienteExistente) {
                if (this.props.contexto === 'atendimento') {
                    Swal.fire({
                        icon: 'warning',
                        title: 'Paciente já cadastrado',
                        text: `O paciente ${pacienteExistente.nome} já está cadastrado neste programa.`,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Selecionar paciente',
                        showCancelButton: true,
                        cancelButtonText: 'Cancelar'
                    }).then((result) => {
                        if (result.isConfirmed) {
                            if (this.props.onAtualizar) {
                                this.props.onAtualizar({
                                    beneficiario_id: pacienteExistente.id,
                                    beneficiario_nome: pacienteExistente.nome
                                });
                            }
                        } else if (result.dismiss === Swal.DismissReason.cancel) {
                            this.setState({ cpf: '' });
                        }
                    });
                } else {
                    Swal.fire({
                        icon: 'warning',
                        title: 'Paciente já cadastrado',
                        text: `Este CPF já está cadastrado no programa.`,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Acessar Cadastro',
                        showCancelButton: true,
                        cancelButtonText: 'Cancelar'
                    }).then((result) => {
                        if (result.isConfirmed) {
                            window.location.href = `/pacientes/edit/${pacienteExistente.id}`;
                        } else if (result.dismiss === Swal.DismissReason.cancel) {
                            this.setState({ cpf: '' });
                        }
                    });
                }
            }
        }
    };

    // Função para calcular idade
    calcularIdade = (dataNascimento) => {
        let nascimento;

        if (typeof dataNascimento === 'string') {
            const dataOnly = dataNascimento.split('T')[0];

            if (dataOnly.includes('/')) {
                const [dia, mes, ano] = dataOnly.split('/');
                nascimento = new Date(+ano, +mes - 1, +dia);
            } else if (dataOnly.includes('-')) {
                const [ano, mes, dia] = dataOnly.split('-');
                nascimento = new Date(+ano, +mes - 1, +dia);
            } else {
                nascimento = new Date(dataNascimento);
            }
        } else {
            // já é Date ou timestamp
            nascimento = new Date(dataNascimento);
        }

        const hoje = new Date();
        let idade = hoje.getFullYear() - nascimento.getFullYear();
        const m = hoje.getMonth() - nascimento.getMonth();

        if (m < 0 || (m === 0 && hoje.getDate() < nascimento.getDate())) {
            idade--;
        }
        return idade;
    }

    tratarNulos = (obj) => {
        const novoObjeto = {};
        for (let key in obj) {
            novoObjeto[key] = (obj[key] === null || obj[key] === "null") ? "" : obj[key];
        }
        return novoObjeto;
    };
    

    enviaPaciente = (e) => {
        e.preventDefault();

        let dados_usuario = getCurrentUser();
        const MySwal = withReactContent(Swal);

        const pre_cadastro_basico = (this.state.programa_dados.habilitar_pre_cadastro_basico && !this.state.paciente_id) ? true : false;  

        const obrigatorioEmailPaciente = getConfig(
            this.state.programa_dados?.configuracoes,
            "validacoes.email_paciente_obrigatorio",
            true // fallback
        );

        const obrigatorioCelularPaciente = getConfig(
            this.state.programa_dados?.configuracoes,
            "validacoes.celular_paciente_obrigatorio",
            true // fallback
        );

        const obrigatorioNascimentoPaciente = getConfig(
            this.state.programa_dados?.configuracoes,
            "validacoes.nascimento_paciente_obrigatorio",
            false // fallback
        );

        const obrigatorioSexoPaciente = getConfig(
            this.state.programa_dados?.configuracoes,
            "validacoes.sexo_paciente_obrigatorio",
            false // fallback
        );

        const dadosCuidadorOpcional = getConfig(
            this.state.programa_dados?.configuracoes,
            "validacoes.dados_cuidador_opcional",
            false // fallback
        );

        // Caregiver requirement flags
        const reqParentescoCuidador = getConfig(this.state.programa_dados?.configuracoes, "validacoes.parentesco_cuidador_obrigatorio", !dadosCuidadorOpcional);
        const reqNomeCuidador = getConfig(this.state.programa_dados?.configuracoes, "validacoes.nome_cuidador_obrigatorio", !dadosCuidadorOpcional);
        const reqCPFCuidador = getConfig(this.state.programa_dados?.configuracoes, "validacoes.cpf_cuidador_obrigatorio", true);
        const reqEmailCuidador = getConfig(this.state.programa_dados?.configuracoes, "validacoes.email_cuidador_obrigatorio", true);
        const reqCelularCuidador = getConfig(this.state.programa_dados?.configuracoes, "validacoes.celular_cuidador_obrigatorio", !dadosCuidadorOpcional);
        const reqTelefoneCuidador = getConfig(this.state.programa_dados?.configuracoes, "validacoes.telefone_cuidador_obrigatorio", false);
        const reqNascimentoCuidador = getConfig(this.state.programa_dados?.configuracoes, "validacoes.nascimento_cuidador_obrigatorio", true);


        // Validação de campos extras de DATA antes de enviar
        for (const campo of this.state.pacientes_campos) {
            if (campo.tipo !== "data") continue;

            const valor = this.state.valoresCamposExtraPaciente[campo.id];
            if (!valor) continue;

            const mascara = campo.mascara || "";

            // 1) Valida min/max
            const limits = getDateLimits(mascara);
            if (limits.min && valor < limits.min) {
                Swal.fire({
                    icon: 'error',
                    title: 'Atenção!',
                    html: `<p>O campo <strong>${campo.nome}</strong> não pode ser menor que ${limits.min}.</p>`,
                    showCloseButton: true,
                });
                return;
            }

            if (limits.max && valor > limits.max) {
                Swal.fire({
                    icon: 'error',
                    title: 'Atenção!',
                    html: `<p>O campo <strong>${campo.nome}</strong> não pode ser maior que ${limits.max}.</p>`,
                    showCloseButton: true,
                });
                return;
            }

            // 2) Valida restrições de dias da semana (seg–qui, etc)
            const allowed = getAllowedWeekdays(mascara);
            if (!isAllowedDateByWeekday(valor, allowed)) {
                Swal.fire({
                    icon: 'error',
                    title: 'Atenção!',
                    html: `<p>A data preenchida no campo <strong>${campo.nome}</strong> não é permitida.</p>`,
                    showCloseButton: true,
                });
                return;
            }

            // 3) Valida no-past
            if (/\bno-past\b/i.test(mascara)) {
                const hoje = todayISO();
                if (valor < hoje) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Atenção!',
                        html: `<p>O campo <strong>${campo.nome}</strong> não pode ser uma data no passado.</p>`,
                        showCloseButton: true,
                    });
                    return;
                }
            }
        }

        const exibirDataNascimentoPreCadastro = getConfig(
            this.state.programa_dados?.configuracoes,
            "pre_cadastro.exbir_data_nascimento",
            true // fallback
        );

        if(!pre_cadastro_basico && ((this.state.doenca_id && this.state.doenca_nome) || (this.state.programa_dados.doenca_principal_id && this.state.programa_dados.doenca_principal_id > 0)) && this.state.programa_dados.exige_confirmacao_diagnostico && this.state.confirmacao_diagnostico === false) {
            MySwal.fire({
                title: 'Atenção!',
                html: <p>É necessário confirmar o diagnóstico do paciente para prosseguir</p>,
                icon: 'error',
                showCloseButton: true,
            });
            return;
        }

        let precisaSalvarEnderecoExtra = false;

        try {
            const laudoHiperFlag = this.state.pacientes_campos.find(c => c.slug === 'laudo-hiperamonemia-flag');

            if (laudoHiperFlag) {
                const valorLaudo = this.state.valoresCamposExtraPaciente[laudoHiperFlag.id];

                if (valorLaudo === 'Sim') {
                    const { cep, endereco, numero, cidade, uf, bairro } = this.state;
                    const enderecoPrincipalCompleto = cep && endereco && numero && cidade && uf && bairro;

                    if (!enderecoPrincipalCompleto) {
                        const { novoEndereco } = this.state;
                        const extraCompleto = novoEndereco.cep && novoEndereco.endereco && novoEndereco.numero && novoEndereco.bairro && novoEndereco.cidade && novoEndereco.uf;

                        if (!extraCompleto) {
                            MySwal.fire({
                                title: 'Endereço de Entrega Obrigatório',
                                html: <p>Para pacientes com laudo de hiperamonemia e cadastro principal incompleto, é <strong>obrigatório</strong> preencher o endereço de entrega do kit (formulário em destaque).</p>,
                                icon: 'warning',
                                showCloseButton: true,
                            });
                            return;
                        }
                        precisaSalvarEnderecoExtra = true;
                    }
                }
            }
        } catch (err) {
            console.error("Erro na validação condicional de endereço: ", err);
        }

        const idade = this.calcularIdade(this.state.data_nascimento);
        if (this.state.programa_dados.id && this.state.programa_dados.permite_menor_idade === false && idade < 18) {
            MySwal.fire({
                title: 'Atenção!',
                html: <p>O programa não permite cadastro de pacientes menores de 18 anos</p>,
                icon: 'error',
                showCloseButton: true,
            });
            return;
        }

        if (!pre_cadastro_basico && this.state.doenca_id && this.state.doenca_idade_minima > 0) {
            if (idade < this.state.doenca_idade_minima) {
                MySwal.fire({
                    title: 'Atenção!',
                    html: <p>Este programa está disponível apenas para pacientes com mais de {this.state.doenca_idade_minima} anos. Em caso de dúvidas ou situações excepcionais, entre em contato com a equipe de atendimento do Programa.</p>,
                    icon: 'error',
                    showCloseButton: true,
                });
                return;
            }

            const vinculoCuidadorMenor = (!this.state.vinculo_cuidador) ? false : this.state.vinculo_cuidador;

            if (idade < 18 && !vinculoCuidadorMenor) {
                MySwal.fire({
                    title: 'Atenção!',
                    html: <p>Para pacientes menores de idade, os dados do responsável legal devem ser informados para concluir o cadastro. O termo de consentimento será enviado ao e-mail do responsável.</p>,
                    icon: 'error',
                    showCloseButton: true,
                });
                return;
            }
        }

        if(exibirDataNascimentoPreCadastro) {
            if (idade < 18 && !this.state.vinculo_cuidador) {
                MySwal.fire({
                    title: 'Atenção!',
                    html: <p>Para pacientes menores de idade, os dados do responsável legal devem ser informados para concluir o cadastro. O termo de consentimento será enviado ao e-mail do responsável.</p>,
                    icon: 'error',
                    showCloseButton: true,
                });
                return;
            }
        }

        // Valida idade máxima 
        if (!pre_cadastro_basico && this.state.doenca_id && this.state.doenca_idade_maxima > 0 && idade > this.state.doenca_idade_maxima) {
            MySwal.fire({
                title: 'Atenção!',
                html: <p>Este programa está disponível apenas para pacientes com menos de {this.state.doenca_idade_maxima} anos. Em caso de dúvidas ou situações excepcionais, entre em contato com a equipe de atendimento do Programa.</p>,
                icon: 'error',
                showCloseButton: true,
            });
            return;
        }

        if (!pre_cadastro_basico && !this.state.cpf_nao_informado && !this.state.cpf) {
            MySwal.fire({
                title: 'Atenção!',
                html: <p>O CPF é obrigatório</p>,
                icon: 'error',
                showCloseButton: true,
            });
            return;
        }

        if((!pre_cadastro_basico || obrigatorioSexoPaciente) && !this.state.genero) {
            MySwal.fire({
                title: 'Atenção!',
                html: <p>Gênero é obrigatório</p>,
                icon: 'error',
                showCloseButton: true,
            });
            return;
        }

        if((!pre_cadastro_basico || obrigatorioNascimentoPaciente) && !this.state.data_nascimento) {
            MySwal.fire({
                title: 'Atenção!',
                html: <p>Data de nascimento é obrigatório</p>,
                icon: 'error',
                showCloseButton: true,
            });
            return; // Interrompe a execução do resto da função
        }

        if((!pre_cadastro_basico || obrigatorioNascimentoPaciente) && !this.state.data_nascimento) {
            MySwal.fire({
                title: 'Atenção!',
                html: <p>Data de nascimento é obrigatório</p>,
                icon: 'error',
                showCloseButton: true,
            });
            return; // Interrompe a execução do resto da função
        }

        const vinculoCuidador = (!this.state.vinculo_cuidador) ? false : this.state.vinculo_cuidador;

        if (!pre_cadastro_basico && (this.state.doenca_idade_minima === 0 || !this.state.doenca_idade_minima) && idade < 18 && !vinculoCuidador) {
            MySwal.fire({
                title: 'Atenção!',
                html: <p>Para pacientes menores de idade, os dados do responsável legal devem ser informados para concluir o cadastro.</p>,
                icon: 'error',
                showCloseButton: true,
            });
            return;
        }

        //Valida cuidador
        if(vinculoCuidador) {

            if(!this.state.tipo_cuidador && reqParentescoCuidador) {
                MySwal.fire({
                    title: 'Atenção!',
                    html: <p>É necessário selecionar o tipo de cuidador/responsável</p>,
                    icon: 'error',
                    showCloseButton: true,
                });
                return;
            }

            if(!this.state.cuidador_nome && reqNomeCuidador) {
                MySwal.fire({
                    title: 'Atenção!',
                    html: <p>É necessário informar o nome do cuidador/responsável</p>,
                    icon: 'error',
                    showCloseButton: true,
                });
                return;
            }

            if(reqCPFCuidador && !this.state.cuidador_cpf) {
                MySwal.fire({
                    title: 'Atenção!',
                    html: <p>É necessário informar o CPF do cuidador/responsável</p>,
                    icon: 'error',
                    showCloseButton: true,
                });
                return;
            }
            
            if(reqEmailCuidador && !this.state.cuidador_email) {
                MySwal.fire({
                    title: 'Atenção!',
                    html: <p>É necessário informar um e-mail do cuidador/responsável</p>,
                    icon: 'error',
                    showCloseButton: true,
                });
                return;
            }

            if(!this.state.cuidador_celular && reqCelularCuidador) {
                MySwal.fire({
                    title: 'Atenção!',
                    html: <p>É necessário informar um celular de contato do cuidador/responsável</p>,
                    icon: 'error',
                    showCloseButton: true,
                });
                return;
            }

            if(!this.state.cuidador_telefone && reqTelefoneCuidador) {
                MySwal.fire({
                    title: 'Atenção!',
                    html: <p>É necessário informar um telefone de contato do cuidador/responsável</p>,
                    icon: 'error',
                    showCloseButton: true,
                });
                return;
            }

            if(!pre_cadastro_basico && this.state.cuidador_data_nascimento && reqNascimentoCuidador) {
                const idadeCuidador = this.calcularIdade(this.state.cuidador_data_nascimento);
                if (idadeCuidador < 18) {
                    MySwal.fire({
                        title: 'Atenção!',
                        html: <p>O cuidador não pode ser menor de 18 anos</p>,
                        icon: 'error',
                        showCloseButton: true,
                    });
                    return;
                }
            } else if (!pre_cadastro_basico && !this.state.cuidador_data_nascimento && reqNascimentoCuidador) {
                MySwal.fire({
                    title: 'Atenção!',
                    html: <p>É necessário informar a data de nascimento do cuidador/responsável</p>,
                    icon: 'error',
                    showCloseButton: true,
                });
                return;
            }
        }

        if(!pre_cadastro_basico && this.state.programa_dados.endereco_paciente_obrigatorio && !this.state.endereco) {
            MySwal.fire({
                title: 'Atenção!',
                html: <p>É necessário informar o endereço do paciente</p>,
                icon: 'error',
                showCloseButton: true,
            });
            return; // Interrompe a execução do resto da função
        }
        if(!pre_cadastro_basico && this.state.programa_dados.endereco_paciente_obrigatorio && !this.state.numero) {
            MySwal.fire({
                title: 'Atenção!',
                html: <p>É necessário informar o número do endereço do paciente</p>,
                icon: 'error',
                showCloseButton: true,  
            });
            return; // Interrompe a execução do resto da função
        }
        if(!pre_cadastro_basico && this.state.programa_dados.endereco_paciente_obrigatorio && !this.state.bairro) {
            MySwal.fire({
                title: 'Atenção!',
                html: <p>É necessário informar o bairro do endereço do paciente</p>,
                icon: 'error',
                showCloseButton: true,  
            });
            return; // Interrompe a execução do resto da função
        }
        if(!pre_cadastro_basico && this.state.programa_dados.endereco_paciente_obrigatorio && !this.state.cidade) {
            MySwal.fire({
                title: 'Atenção!',
                html: <p>É necessário informar a cidade do endereço do paciente</p>,
                icon: 'error',
                showCloseButton: true,  
            });
            return; // Interrompe a execução do resto da função
        }
        if(!pre_cadastro_basico && this.state.programa_dados.endereco_paciente_obrigatorio && !this.state.uf) {
            MySwal.fire({
                title: 'Atenção!',
                html: <p>É necessário informar o estado do endereço do paciente</p>,
                icon: 'error',
                showCloseButton: true,    
            });
            return; // Interrompe a execução do resto da função
        }
        const formData = new FormData();

        this.setState({
            loading: true,
            nomeHelper: '',
            cpfHelper: '',
            emailHelper: '',
            telefoneHelper: '',
            enderecoTelefoneHelper: '',
            celularHelper: '',
        });

        // verifica se é edição ou adição
        const url = (this.state.paciente_id) ? '/pessoas/beneficiarios/' + this.state.paciente_id + '/?cliente_id=' + this.state.cliente_id : '/pessoas/beneficiarios/'
        const metodo = (this.state.paciente_id) ? 'put' : 'post'
        
        formData.append('nome', this.state.nome);
        if (!this.state.cpf_nao_informado) {
            formData.append('cpf', this.state.cpf || '');
        } else {
            formData.append('cpf', '');
        }
        formData.append('data_nascimento', this.state.data_nascimento);
        formData.append('genero', this.state.genero);
        formData.append('email', this.state.email || '');
        formData.append('telefone', this.state.telefone);
        formData.append('endereco_telefone', this.state.endereco_telefone);
        formData.append('celular', this.state.celular);
        formData.append('cep', this.state.cep || '');
        formData.append('endereco', this.state.endereco || '');
        formData.append('numero', this.state.numero || '');
        formData.append('complemento', this.state.complemento || '');
        formData.append('bairro', this.state.bairro || '');
        formData.append('cidade', this.state.cidade || '');
        formData.append('uf', this.state.uf || '');
        formData.append('plano_saude', this.state.plano_saude || '');
        formData.append('numero_carteirinha', this.state.numero_carteirinha || '');
        formData.append('aceita_receber_whatsapp', this.state.aceita_receber_whatsapp);
        formData.append('aceita_receber_emails', this.state.aceita_receber_emails);
        formData.append('aceita_receber_ligacoes', this.state.aceita_receber_ligacoes);

        if (this.state.nome_local) {
            formData.append('nome_local', this.state.nome_local);
        }

        if (this.state.medico_id) {
            formData.append('medico_id', this.state.medico_id);
        }

        if (this.state.doenca_id) {
            formData.append('doenca_id', this.state.doenca_id);
        }

        const cliente_id = dados_usuario['ambiente_cliente_id'] || this.state.cliente_id;
        const programa_id = dados_usuario['ambiente_programa_id'] || this.state.programa_id;

        formData.append('cliente_id', cliente_id);
        formData.append('programa_id', programa_id);

        // cuidador
        formData.append('vinculo_cuidador', vinculoCuidador);
        if (vinculoCuidador) {
            formData.append('tipo_cuidador', this.state.tipo_cuidador);
            formData.append('cuidador_nome', this.state.cuidador_nome);
            formData.append('cuidador_cpf', this.state.cuidador_cpf);

            if (this.state.cuidador_data_nascimento) {
                formData.append('cuidador_data_nascimento', this.state.cuidador_data_nascimento);
            }

            if (this.state.cuidador_endereco) {
                formData.append('cuidador_endereco', this.state.cuidador_endereco);
            }

            if (this.state.cuidador_celular) {
                formData.append('cuidador_celular', this.state.cuidador_celular);
            }

            if (this.state.cuidador_telefone) {
                formData.append('cuidador_telefone', this.state.cuidador_telefone);
            }

            if (this.state.cuidador_email) {
                formData.append('cuidador_email', this.state.cuidador_email);
            }
        }

        // campos extras do atendimento
        let cont = 1;
        Object.entries(this.state.valoresCamposExtraPaciente).forEach(([campoId, valor]) => {
            if (valor instanceof File) {
                formData.append(`extra_valor_arquivo_${cont}`, valor);
            }
            else if (typeof valor === 'boolean') {
                formData.append(`extra_valor_valor_${cont}`, valor ? 'true' : 'false');
            }
            else {
                formData.append(`extra_valor_valor_${cont}`, valor);
            }

            formData.append(`extra_valor_campo_id_${cont}`, campoId);
            cont++;
        });

        formData.append('cadastro_teste', this.state.cadastro_teste);

        // documento do cuidador (anexa apenas se o usuário selecionou um novo)
        if (this.state.cuidador_documento_file instanceof File) {
            formData.append('cuidador_documento', this.state.cuidador_documento_file);
        }
        
        //envia para api
        api({
            method: metodo,
            url: url,
            data: formData
        })
        .then(async (response) => {
            const MySwal = withReactContent(Swal)
            const idPacienteSalvo = response.data.id;          

            if (precisaSalvarEnderecoExtra) {
                try {
                    await this.salvarNovoEndereco(idPacienteSalvo);
                } catch (errEndereco) {
                    console.error("Erro ao salvar endereço extra", errEndereco);
                    MySwal.fire({ title: 'Aviso', text: 'Paciente salvo, mas erro no endereço do kit.', icon: 'warning' })
                }
            }

            if (this.props.onUpdateKitFlag) {
                try {
                    const campoLaudo = this.state.pacientes_campos.find(c => c.slug === 'laudo-hiperamonemia-flag');
                    
                    if (campoLaudo) {
                        let valorLaudo = this.state.valoresCamposExtraPaciente[campoLaudo.id] 
                                      || this.state.valoresCamposExtraPaciente[String(campoLaudo.id)];

                        if (valorLaudo === undefined || valorLaudo === null) {
                             const itemSalvo = this.state.extra_valores_list.find(v => v.campo_slug === 'laudo-hiperamonemia-flag');
                             if (itemSalvo) valorLaudo = itemSalvo.valor;
                        }

                        if (String(valorLaudo).trim() === 'Sim') {
                            this.props.onUpdateKitFlag(); 
                        }
                    }
                } catch (errKit) {
                    console.error("Erro ao processar flag do kit:", errKit);
                }
            }

            if (this.props.onAtualizar) {
                this.setState({ loading: false })
                
                const dados_paciente = {
                    beneficiario_id: response.data.id,
                    beneficiario_nome: response.data.nome
                }
                this.props.onAtualizar(dados_paciente);
            
            } 
            else if (!this.state.paciente_id) {
                this.setState({ loading: false });

                await MySwal.fire({
                    title: 'Sucesso!',
                    text: 'Paciente cadastrado com sucesso',
                    icon: 'success',
                    confirmButtonText: 'OK'
                });

                this.props.router.navigate("/pacientes");
            
            } 
            else {
                this.setState({ loading: false });
                
                await MySwal.fire({
                    title: 'Sucesso!',
                    text: 'Paciente atualizado com sucesso',
                    icon: 'success',
                    confirmButtonText: 'OK'
                });
                
                this.props.router.navigate("/pacientes");
            }
        })      
        .catch(error => {
            let erro_msg = "<strong>Verifique os itens abaixo:</strong><br />";

            if (error.response && error.response.status === 500) {
                erro_msg = 'Servidor indisponível no momento, tente novamente dentro de alguns minutos';
            }
            else if (error.response && error.response.status === 400) {
                const campos = error.response.data;

                const camposTratadosVisualmente = [
                    'nome', 'data_nascimento', 'cpf', 'cpf_cnpj', 'email',
                    'telefone', 'endereco_telefone', 'celular', 'cep',
                    'endereco', 'nome_local', 'numero', 'complemento',
                    'bairro', 'cidade', 'uf', 'tipo_cuidador', 'cuidador_nome',
                    'cuidador_cpf', 'cuidador_data_nascimento', 'cuidador_endereco',
                    'cuidador_celular', 'cuidador_telefone', 'cuidador_email'
                ];

                for (let key in campos) {
                    var value = campos[key];

                    if (key === 'nome') { this.setState({ nomeFantasiaHelper: value }) }
                    if (key === 'data_nascimento') { this.setState({ dataNascimentoHelper: value }) }
                    if (key === 'cpf' || key === 'cpf_cnpj') { this.setState({ cpfHelper: value }) }
                    if (key === 'email') { this.setState({ emailHelper: value }) }
                    if (key === 'telefone') { this.setState({ telefoneHelper: value }) }
                    if (key === 'endereco_telefone') { this.setState({ enderecoTelefoneHelper: value }) }
                    if (key === 'celular') { this.setState({ celularHelper: value }) }
                    if (key === 'cep') { this.setState({ cepHelper: value }) }
                    if (key === 'endereco') { this.setState({ enderecoHelper: value }) }
                    if (key === 'nome_local') { this.setState({ nomeLocalHelper: value }) }
                    if (key === 'numero') { this.setState({ numeroHelper: value }) }
                    if (key === 'complemento') { this.setState({ complementoHelper: value }) }
                    if (key === 'bairro') { this.setState({ bairroHelper: value }) }
                    if (key === 'cidade') { this.setState({ cidadeHelper: value }) }
                    if (key === 'uf') { this.setState({ ufHelper: value }) }

                    if (key === 'tipo_cuidador')
                        if (key === 'cuidador_nome') { this.setState({ cuidadorNomeHelper: value }) }
                    if (key === 'cuidador_cpf') { this.setState({ cuidadorCpfHelper: value }) }
                    if (key === 'cuidador_data_nascimento') { this.setState({ cuidadorDataNascimentoHelper: value }) }
                    if (key === 'cuidador_endereco') { this.setState({ cuidadorEnderecoHelper: value }) }
                    if (key === 'cuidador_celular') { this.setState({ cuidadorCelularHelper: value }) }
                    if (key === 'cuidador_telefone') { this.setState({ cuidadorTelefoneHelper: value }) }
                    if (key === 'cuidador_email') { this.setState({ cuidadorEmailHelper: value }) }

                    let msgErro = Array.isArray(value) ? value[0] : value;

                    if (camposTratadosVisualmente.includes(key)) {
                        //  erro_msg += `<br />&bull; ${msgErro}`;
                    } else {
                        erro_msg += `<br />&bull; ${msgErro}`;
                    }
                }
            }

            const MySwal = withReactContent(Swal)
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: 'Atenção',
                html: <p dangerouslySetInnerHTML={{ __html: erro_msg }}></p>,
            })

            this.setState({
                loading: false,
            })
        });
    };

    handleChange = (event, fieldName) => {
        if(fieldName == 'cliente_id') {
            this.setState({ 
                cliente_id: event.value, 
                cliente_nome: event.label,
                programa_id: '',  // Limpa o ID do programa selecionado
                programa_nome: '',  // Limpa o nome do programa selecionado
            });
        } 
        else if (fieldName == 'programa_id') {
            this.setState({ 
                programa_id: event.value, 
                programa_nome: event.label,
                exige_cpf_atendimento: event.exige_cpf_atendimento,
            }, () => {
                this.carregaDadosPrograma();
            });
        } 
        else if(fieldName == 'plano_id') {
            this.setState({ plano_id: event.value, plano_nome: event.label });
        } 
        else {
            const { name, value } = event.target;

            if(name == 'data_nascimento') {
                const currentDate = new Date();
                const selectedDate = new Date(value);
                const maxDate = new Date();
                const minDate = new Date();
                minDate.setFullYear(maxDate.getFullYear() - 120);
    
                let dataNascimentoHelper = '';
    
                if (selectedDate > maxDate) {
                    dataNascimentoHelper = 'Data de nascimento não pode ser no futuro.';
                } else if (selectedDate < minDate) {
                    dataNascimentoHelper = 'Data de nascimento inválida.';
                }
    
                this.setState({
                    [name]: value,
                    dataNascimentoHelper
                });
            } else if(name == 'cuidador_data_nascimento') {
                const currentDate = new Date();
                const selectedDate = new Date(value);
                const maxDate = new Date();
                const minDate = new Date();
                minDate.setFullYear(maxDate.getFullYear() - 120);
    
                let cuidadorDataNascimentoHelper = '';
    
                if (selectedDate > maxDate) {
                    cuidadorDataNascimentoHelper = 'Data de nascimento não pode ser no futuro.';
                } else if (selectedDate < minDate) {
                    cuidadorDataNascimentoHelper = 'Data de nascimento inválida.';
                }
    
                this.setState({
                    [name]: value,
                    cuidadorDataNascimentoHelper
                });
            } else {
                this.setState({ [name]: value });
            }

            
        }
    };

    handlePaste(event) {
        const { name, value } = event.target;
        const valor = event.clipboardData.getData('Text');
        this.setState({ [name]: valor });
    }

    handlePasteCep(e) {
        const cep = e.clipboardData.getData('Text');
        this.setState({ cep: cep });

        //if (cep.length === 9) { // Verifica se o CEP tem 9 caracteres
        axios.get(`https://viacep.com.br/ws/${cep}/json/`)
            .then(res => {
                if (!res.data.erro) {
                    this.setState({
                        endereco: res.data.logradouro,
                        complemento: res.data.complemento,
                        bairro: res.data.bairro,
                        cidade: res.data.localidade,
                        uf: res.data.uf
                    });
                } else {
                    // Tratar o caso de CEP não encontrado
                    console.log("CEP não encontrado.");
                }
            })
            .catch(error => {
                // Tratar erro na requisição
                console.error("Erro na requisição:", error);
            });
        //}
    }
    
    carregarProgramasCliente = async (inputValue, cliente_id) => {
        try {
            const response = await api.get(`/programas/?nome=${inputValue}&cliente_id=${cliente_id}`);
            const opcoes = response.data.results.map(programa => ({
                value: programa.id,
                label: programa.nome,
                exige_cpf_atendimento: programa.exige_cpf_atendimento
            }));
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar programas do cliente:', error);
            return [];
        }
    };

    onChangeCep(e) {
        const cep = e.target.value;
        this.setState({ cep: cep });

        if (cep.length === 9) { // Verifica se o CEP tem 9 caracteres
            axios.get(`https://viacep.com.br/ws/${cep}/json/`)
                .then(res => {
                    if (!res.data.erro) {
                        this.setState({
                            endereco: res.data.logradouro,
                            complemento: res.data.complemento,
                            bairro: res.data.bairro,
                            cidade: res.data.localidade,
                            uf: res.data.uf
                        });
                    } else {
                        // Tratar o caso de CEP não encontrado
                        console.log("CEP não encontrado.");
                    }
                })
                .catch(error => {
                    // Tratar erro na requisição
                    console.error("Erro na requisição:", error);
                });
        }
    }

    //Doenças do Paciente
    carregarDoencasPaciente = () => {
        if (this.state.paciente_id) {
            api.get(`/pessoas/beneficiarios/doencas/?beneficiario_id=${this.state.paciente_id}`)
                .then(response => {
                    console.log(response);
                    const doencasCarregadas = response.data.results.map(doenca => ({
                        id: doenca.id,
                        doenca_id: doenca.doenca_id,
                        doenca_nome: doenca.dados_doenca.descricao
                    }));
                    this.setState({ doencas: doencasCarregadas });
                })
                .catch(error => {
                    console.error('Erro ao carregar doenças:', error);
                    
                    let erro_msg = 'Erro ao carregar doençcas do paciente, tente novamente';

                    if(error.response && error.response.status === 500){
                        erro_msg = 'Servidor indisponível no momento, tente novamente';
                    }

                    this.setState({
                        erroLoadRegistro: erro_msg,
                    })
                });
        }
    };

    salvarDoenca = (index) => {
        const doenca = this.state.doencas[index];
        const url = (doenca.id) ? `/pessoas/beneficiarios/doencas/${doenca.id}/` : '/pessoas/beneficiarios/doencas/';
        const metodo = (doenca.id) ? 'put' : 'post';

        const dadosDoenca = {
            beneficiario_id: this.state.paciente_id,
            doenca_id: doenca.doenca_id,
            tipo_doenca: 'doenca_alvo'
        };

        api({
            method: metodo,
            url: url,
            data: dadosDoenca,
        })
        .then(response => {
            // Se um novo registro, atualize o estado com a ID retornada pela API
            if (!doenca.id) {
                this.setState(prevState => {
                    const doencasAtualizadas = [...prevState.doencas];
                    doencasAtualizadas[index].id = response.data.id;
                    return { doencas: doencasAtualizadas };
                });
            }
            
            const MySwal = withReactContent(Swal)
            const textSwal = (doenca.id) ? 'Doença atualizada com sucesso' : 'Doença cadastrada com sucesso';

            MySwal.fire({
                title: 'Sucesso!',
                html: <p>{textSwal}</p>,
                icon: 'success',
                showCloseButton: true,
            })
            
        })
        .catch(error => {
            let erro_msg = 'Erro ao cadastrar a doença, verifique os campos e tente novamente';   
            let content = '';         

            if(error.response && error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response && error.response.status === 400){
                const campos = error.response.data;                
                
                //percorre os campos com erro
                for (let key in campos){
                    var value = campos[key];

                    if(key == 'beneficiario_id') {
                        content += `<br>&bull; Paciente: ${value}`;
                    }
                    if(key == 'doenca_id') {
                        content += `<br>&bull; Doença: ${value}`;
                    }
                }
            }

            const MySwal = withReactContent(Swal)
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: <p>{erro_msg}</p>,
                html: content,
            })
        });
    };

    adicionarDoenca = () => {
        this.setState(prevState => ({
            doencas: [...prevState.doencas, { doenca_id: '', doenca_nome: '' }],
        }));
    };

    removerDoenca = (index) => {
        const MySwal = withReactContent(Swal);
    
        MySwal.fire({
            title: 'Remover doença?',
            text: "Tem certeza que deseja remover esta doença?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim, remover!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {

                const doenca = this.state.doencas[index];

                if (doenca.id) {

                    const url = `/pessoas/beneficiarios/doencas/${doenca.id}/`;
                    const metodo = 'delete';
                
                    api({
                        method: metodo,
                        url: url
                    })
                    .then(response => {
                                              
                        const MySwal = withReactContent(Swal)
                        const textSwal = 'Doença removida com sucesso';

                        MySwal.fire({
                            title: 'Sucesso!',
                            html: <p>{textSwal}</p>,
                            icon: 'success',
                            showCloseButton: true,
                        })

                        this.setState(prevState => ({
                            doencas: prevState.doencas.filter((_, i) => i !== index),
                        }));
                        
                    })
                    .catch(error => {
                        let erro_msg = 'Erro ao remover a doença, tente novamente';            

                        if(error.response && error.response.status === 500){
                            erro_msg = 'Servidor indisponível no momento';
                        }
                        else if(error.response && error.response.status === 400){
                            const campos = error.response.data;       
                            
                        }

                        const MySwal = withReactContent(Swal)
                        MySwal.fire({
                            icon: 'error',
                            showCloseButton: true,
                            title: <p>{erro_msg}</p>,
                        })
                    });

                } else {
                    this.setState(prevState => ({
                        doencas: prevState.doencas.filter((_, i) => i !== index),
                    }));
        
                    MySwal.fire(
                        'Removido!',
                        'A doença foi removida.',
                        'success'
                    );
                }
            }
        });
    };

    handleDoencaChange = (index, event, fieldName) => {
        this.setState(prevState => {
            // Clonando o array de doenças para não mutar o estado diretamente
            const doencasAtualizadas = [...prevState.doencas];
            
            // Atualizando doença específico baseado no fieldName
            if (fieldName === 'doenca_id') {
                doencasAtualizadas[index] = { ...doencasAtualizadas[index], doenca_id: event.value, doenca_nome: event.label };
            } else {
                doencasAtualizadas[index] = { ...doencasAtualizadas[index], [event.target.name]: event.target.value };
            }
    
            // Retornando o novo estado com o array de prestadores atualizado
            return { doencas: doencasAtualizadas };
        });
    };

    carregarDoencas = async (inputValue) => {
        try {
            const response = await api.get(`/doencas/?nome=${inputValue}`);
            const opcoes = response.data.results.map(doenca => ({
                value: doenca.id,
                label: doenca.nome
            }));
            //this.setState({ opcoesClientes: opcoes });
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar doenças:', error);
            return [];
        }
    };


    //Médicos do Paciente
    carregarMedicosPaciente = () => {
        if (this.state.paciente_id) {
            api.get(`/pessoas/beneficiarios/medicos/?beneficiario_id=${this.state.paciente_id}`)
                .then(response => {
                    console.log(response);
                    const medicosCarregados = response.data.results.map(medico => ({
                        id: medico.id,
                        prestador_id: medico.prestador_id,
                        prestador_nome: medico.dados_prestador.nome
                    }));
                    this.setState({ medicos: medicosCarregados });
                })
                .catch(error => {
                    console.error('Erro ao carregar médicos:', error);
                    
                    let erro_msg = 'Erro ao carregar médicos do paciente, tente novamente';

                    if(error.response && error.response.status === 500){
                        erro_msg = 'Servidor indisponível no momento, tente novamente';
                    }

                    this.setState({
                        erroLoadRegistro: erro_msg,
                    })
                });
        }
    };

    salvarMedico = (index) => {
        const medico = this.state.medicos[index];
        const url = (medico.id) ? `/pessoas/beneficiarios/medicos/${medico.id}/` : '/pessoas/beneficiarios/medicos/';
        const metodo = (medico.id) ? 'put' : 'post';

        const dadosMedico = {
            beneficiario_id: this.state.paciente_id,
            prestador_id: medico.prestador_id
        };

        api({
            method: metodo,
            url: url,
            data: dadosMedico,
        })
        .then(response => {
            // Se um novo registro, atualize o estado com a ID retornada pela API
            if (!medico.id) {
                this.setState(prevState => {
                    const medicosAtualizados = [...prevState.medicos];
                    medicosAtualizados[index].id = response.data.id;
                    return { medicos: medicosAtualizados };
                });
            }
            
            const MySwal = withReactContent(Swal)
            const textSwal = (medico.id) ? 'Médico atualizado com sucesso' : 'Médico cadastrado com sucesso';

            MySwal.fire({
                title: 'Sucesso!',
                html: <p>{textSwal}</p>,
                icon: 'success',
                showCloseButton: true,
            })
            
        })
        .catch(error => {
            let erro_msg = 'Erro ao cadastrar o médico, verifique os campos e tente novamente';   
            let content = '';         

            if(error.response && error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response && error.response.status === 400){
                const campos = error.response.data;                
                
                //percorre os campos com erro
                for (let key in campos){
                    var value = campos[key];

                    if(key == 'beneficiario_id') {
                        content += `<br>&bull; Paciente: ${value}`;
                    }
                    if(key == 'medico_id') {
                        content += `<br>&bull; Médico: ${value}`;
                    }
                }
            }

            const MySwal = withReactContent(Swal)
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: <p>{erro_msg}</p>,
                html: content,
            })
        });
    };

    adicionarMedico = () => {
        this.setState(prevState => ({
            medicos: [...prevState.medicos, { prestador_id: '', prestador_nome: '' }],
        }));
    };

    removerMedico = (index) => {
        const MySwal = withReactContent(Swal);
    
        MySwal.fire({
            title: 'Remover médico?',
            text: "Tem certeza que deseja remover este médico?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim, remover!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {

                const medico = this.state.medicos[index];

                if (medico.id) {

                    const url = `/pessoas/beneficiarios/medicos/${medico.id}/`;
                    const metodo = 'delete';
                
                    api({
                        method: metodo,
                        url: url
                    })
                    .then(response => {
                                              
                        const MySwal = withReactContent(Swal)
                        const textSwal = 'Médico removido com sucesso';

                        MySwal.fire({
                            title: 'Sucesso!',
                            html: <p>{textSwal}</p>,
                            icon: 'success',
                            showCloseButton: true,
                        })

                        this.setState(prevState => ({
                            medicos: prevState.medicos.filter((_, i) => i !== index),
                        }));
                        
                    })
                    .catch(error => {
                        let erro_msg = 'Erro ao remover o médico, tente novamente';            

                        if(error.response && error.response.status === 500){
                            erro_msg = 'Servidor indisponível no momento';
                        }
                        else if(error.response && error.response.status === 400){
                            const campos = error.response.data;       
                            
                        }

                        const MySwal = withReactContent(Swal)
                        MySwal.fire({
                            icon: 'error',
                            showCloseButton: true,
                            title: <p>{erro_msg}</p>,
                        })
                    });

                } else {
                    this.setState(prevState => ({
                        medicos: prevState.medicos.filter((_, i) => i !== index),
                    }));
        
                    MySwal.fire(
                        'Removido!',
                        'O médico foi removido.',
                        'success'
                    );
                }
            }
        });
    };

    handleMedicoChange = (index, event, fieldName) => {
        this.setState(prevState => {
            // Clonando o array de doenças para não mutar o estado diretamente
            const medicosAtualizados = [...prevState.medicos];
            
            // Atualizando doença específico baseado no fieldName
            if (fieldName === 'prestador_id') {
                medicosAtualizados[index] = { ...medicosAtualizados[index], prestador_id: event.value, prestador_nome: event.label };
            } else {
                medicosAtualizados[index] = { ...medicosAtualizados[index], [event.target.name]: event.target.value };
            }
    
            // Retornando o novo estado com o array de prestadores atualizado
            return { medicos: medicosAtualizados };
        });
    };

    carregarMedicos = async (inputValue) => {
        const dados_usuario = getCurrentUser();
        try {
            const response = await api.get(`/pessoas/prestadores/?nome=${inputValue}&categoria=medicos&tipo_usuario=${dados_usuario.tipo_usuario}`);
            const opcoes = response.data.results.map(prestador => ({
                value: prestador.id,
                label: prestador.nome
            }));
            //this.setState({ opcoesClientes: opcoes });
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar médicos:', error);
            return [];
        }
    };

    handleChangeCampoPacienteExtra = (id, value) => {
        const isEvent = value && value.target;
        let finalValue = value;

        console.log('[MASK-DEBUG][CHANGE] input', {
            id,
            isEvent,
            rawType: isEvent ? value?.target?.type : typeof value,
            rawValue: isEvent ? value?.target?.value : value
        });
    
        if (isEvent) {
            const target = value.target;
    
            if (target.type === "file") {
                finalValue = target.files[0];
            }
    
            //Checkbox
            else if (target.type === "checkbox") {
                const valoresAnteriores = this.state.valoresCamposExtraPaciente?.[id]
                    ? this.state.valoresCamposExtraPaciente[id].split(',')
                    : [];
    
                const valorAtual = target.value;
    
                let novosValores;
                if (target.checked) {
                    // Adiciona valor se ainda não existe
                    novosValores = [...valoresAnteriores, valorAtual].filter((v, i, arr) => arr.indexOf(v) === i);
                } else {
                    // Remove valor
                    novosValores = valoresAnteriores.filter(v => v !== valorAtual);
                }
    
                finalValue = novosValores.join(',');
            }
    
            else if (target.type === "radio") {
                finalValue = target.value;
            }
    
            else {
                finalValue = target.value;
            }
        }
    
        // Atualiza o estado
        this.setState(prevState => ({
            valoresCamposExtraPaciente: {
                ...prevState.valoresCamposExtraPaciente,
                [id]: finalValue,
            },
        }), () => {
            console.log('[MASK-DEBUG][CHANGE] state updated', {
                id,
                finalValue,
                valoresCamposExtraPaciente: this.state.valoresCamposExtraPaciente
            });
        });
    };
    

    abrirModalHistorico = async (campoId, campoNome) => {
        const { paciente_id } = this.state;
    
        if (paciente_id && campoId) {
            try {
            const { data } = await api.get(
                `/pessoas/beneficiarios/campos/historico/?beneficiario_id=${paciente_id}&limit=100`
            );

            // A API, com bug, pode retornar array direto ou { results: [] }
            const rowsRaw = Array.isArray(data) ? data : (data?.results || []);

            // FILTRO TEMPORÁRIO NO FRONT -> pelo beneficiario_campo_id
            const filtrado = rowsRaw.filter(
                (r) => Number(r.beneficiario_campo_id) === Number(campoId)
            );

            // Ordena do mais recente para o mais antigo
            filtrado.sort(
                (a, b) => new Date(b.data_historico) - new Date(a.data_historico)
            );

            this.setState({
                campo_historico: filtrado,
                historicoCampoAtual: { id: campoId, nome: campoNome },
                showHistoricoModal: true,
            });
            } catch (error) {
                console.error('Erro ao carregar histórico:', error);
                Sentry.captureException(error);
            }
        }
    };
    
    fecharModalHistorico = () => {
        this.setState({ showHistoricoModal: false });
    };

    // Render do modal (React-Bootstrap). Ele cria portal para <body>, então não "quebra" se já estiver dentro de outro modal.
    renderHistoricoModal = () => {
        const { showHistoricoModal, historicoCampoAtual, campo_historico } = this.state;

        // Se houver pelo menos um item com arquivo não vazio, mostra a coluna Arquivo
        const hasArquivo = (campo_historico || []).some(
            (h) => h.arquivo && String(h.arquivo).trim() !== ''
        );

        return (
            <Modal
            show={showHistoricoModal}
            onHide={this.fecharModalHistorico}
            centered
            size="lg"
            scrollable
            backdrop="static"
            restoreFocus={false}
            >
            <Modal.Header closeButton>
                <Modal.Title>
                Histórico {historicoCampoAtual ? `– ${historicoCampoAtual.nome}` : ''}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {(!campo_historico || campo_historico.length === 0) ? (
                <div className="text-muted">Nenhum histórico encontrado.</div>
                ) : (
                <Table striped bordered hover>
                    <thead>
                    <tr>
                        <th style={{ whiteSpace: 'nowrap' }}>Data</th>
                        <th>Valor</th>
                        {hasArquivo && <th style={{ whiteSpace: 'nowrap' }}>Arquivo</th>}
                    </tr>
                    </thead>
                    <tbody>
                    {campo_historico.map((h, idx) => (
                        <tr key={idx}>
                        <td>{formataDataHoraExibicao(h.data_historico)}</td>
                        <td>{h.valor ?? '-'}</td>
                        {hasArquivo && (
                            <td>
                            {h.arquivo && String(h.arquivo).trim() !== '' ? (
                                <a href={h.arquivo} target="_blank" rel="noreferrer">
                                Baixar
                                </a>
                            ) : (
                                '-'
                            )}
                            </td>
                        )}
                        </tr>
                    ))}
                    </tbody>
                </Table>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={this.fecharModalHistorico}>
                Fechar
                </Button>
            </Modal.Footer>
            </Modal>
        );
    };

    getValoresCamposExtra = () => {
        const valores = {};
        for (const campo of this.state.pacientes_campos) {
            const valorAtual = this.state.valoresCamposExtraPaciente[campo.id];
            valores[campo.slug] = valorAtual !== undefined ? valorAtual : campo.valor;
        }
        return valores;
    };


    renderAlertasCondicionais = (campo, valoresAtuais) => {
        let dados_usuario = getCurrentUser();
        if (dados_usuario?.prestador_categoria !== 'medicos') {
            return null;
        }

        const valor = valoresAtuais[campo.slug];

        switch (campo.slug) {
            // DOENÇA 1: Acidemias Orgânicas (Hiperamonemia)
            case 'laudo-hiperamonemia-flag':
                if (valor === 'Sim') {
                    const { cep, endereco, numero, cidade, uf, bairro } = this.state;
                    const enderecoPrincipalPreenchido = cep && endereco && numero && cidade && uf && bairro;

                    if (enderecoPrincipalPreenchido) {
                        return (
                            <Col xs={12}>
                                <Alert variant="success" className="mt-2 small">
                                    <FaCheck className="me-1"/> Em breve o programa encaminhará o kit para o endereço do cadastro principal.
                                </Alert>
                            </Col>
                        );
                    } else {
                        return (
                            <Col xs={12}>
                                <Alert variant="warning" className="mt-2 small mb-0">
                                    <strong>Atenção Dr (a):</strong> Para essa condição disponibilizamos o exame de Perfil TANDEM-NEOTANDEM. 
                                    Por favor <strong>preencha o endereço de entrega abaixo</strong> para envio do material.
                                </Alert>
                                {this.renderFormularioEnderecoExtra()}
                            </Col>
                        );
                    }
                }
                return null;

            // DOENÇA 1 (Continuação): Solicitação Amônia
            case 'solicita_exame_dosagem_amonia':
                if (valor === 'Não') {
                    return (
                        <Col xs={12}>
                            <Alert variant="warning" className="mt-2 small">
                                <strong>Aviso:</strong> Um profissional do programa entrará em contato em até 24 horas úteis.
                            </Alert>
                            <Alert variant="success" className="mt-2 small">
                                O exame de genotipagem poderá ser disponibilizado de acordo com os critérios de elegibilidade do programa, para mais informações entre em contato com o programa pelos canais de atendimento.
                            </Alert>
                        </Col>
                    );
                }
                return null;

            // DOENÇA 2: Porfiria
            case 'repeticao_exame_porfiria':
                if (valor === 'Não') {
                    return (
                        <Col xs={12}>
                            <Alert variant="warning" className="mt-2 small">
                                Um profissional do programa entrará em contato em até 24 horas úteis.
                            </Alert>
                        </Col>
                    );
                }
                return null;

            // DOENÇA 3: Acromegalia
            case 'diagnostico-de-acromegalia':
                if (valor === 'Não') {
                    return (
                        <Col xs={12}>
                            <Alert variant="warning" className="mt-2 small">
                                Um profissional do programa entrará em contato em até 24 horas úteis.
                            </Alert>
                        </Col>
                    );
                }
                return null;

            default:
                return null;
        }
    };




    renderPolicyAcceptField = (campo, hasDivisor = false, programaAtual = null, mapaPosicoes = null) => {
        console.log('[MASK-DEBUG][POLICY] render start', {
            slug: campo?.slug,
            id: campo?.id,
            tipo: campo?.tipo,
            mascara: campo?.mascara,
            hasDivisor
        });

        const camposAntes = mapaPosicoes && mapaPosicoes[campo.slug]?.before
            ? mapaPosicoes[campo.slug].before.map(c => this.renderCampoPersonalizadoInline(c, programaAtual, mapaPosicoes))
            : null;

        const camposDepois = mapaPosicoes && mapaPosicoes[campo.slug]?.after
            ? mapaPosicoes[campo.slug].after.map(c => this.renderCampoPersonalizadoInline(c, programaAtual, mapaPosicoes))
            : null;

        if (campo.tipo !== 'checkbox' && campo.tipo !== 'radio') {
            return (
                <>
                    {camposAntes}
                    {this.renderCampoPersonalizadoInline(campo, programaAtual, null)}
                    {camposDepois}
                </>
            );
        }

        const valorAtual = (this.state.valoresCamposExtraPaciente?.[campo.id] ?? campo.valor ?? '').toString();
        const valoresSelecionados = valorAtual.split(',').map(item => item.trim()).filter(Boolean);

        return (
            <React.Fragment key={campo.id}>
                {camposAntes}
                {hasDivisor && <Col xs={12} className="w-100"><hr className="my-4" style={{ borderTop: '1px solid #ddd' }} /></Col>}
                <Col xs={12} className="mb-4">
                    <div className="policy-accept-container mt-2">
                        <Form.Label>
                            {campo.nome}
                            {campo.obrigatorio && (
                                <>
                                    <span className="text-danger ms-1" aria-hidden="true">*</span>
                                    <span className="visually-hidden"> obrigatório</span>
                                </>
                            )}
                        </Form.Label>
                        
                        {campo.descricao && (
                            <Form.Text className="text-muted d-block mb-3" style={{ fontSize: '0.9em', textAlign: 'justify', lineHeight: '1.5' }}>
                                {campo.descricao}
                            </Form.Text>
                        )}
                        
                        <div className={campo.tipo === 'radio' ? 'policy-radios' : 'policy-checkboxes ps-2'}>
                            {(campo.opcoes || '').split('\n').map((opcao, idx) => {
                                const [valor, labelOriginal] = opcao.split(':');
                                let labelExibicao = labelOriginal || valor;

                                return (
                                    <Form.Check
                                        key={`policy_option_${campo.id}_${idx}`}
                                        type={campo.tipo === 'radio' ? 'radio' : 'checkbox'}
                                        name={campo.tipo === 'radio' ? `policy_radio_${campo.id}` : undefined}
                                        inline={campo.tipo === 'radio'}
                                        label={<span style={{ display: 'inline-block', paddingLeft: '8px' }}>{labelExibicao}</span>}
                                        value={valor}
                                        checked={campo.tipo === 'radio' ? valorAtual === valor : valoresSelecionados.includes(valor)}
                                        onChange={(e) => this.handleChangeCampoPacienteExtra(campo.id, e)}
                                        required={campo.obrigatorio}
                                        className={campo.tipo === 'radio' ? 'me-3 mb-2' : 'mb-3 d-flex align-items-start'}
                                        style={{ fontSize: '1.05rem', fontWeight: '400' }}
                                    />
                                );
                            })}
                        </div>
                    </div>
                </Col>
                {camposDepois}
            </React.Fragment>
        );
    }


    renderizaCamposExtraBeneficiario = () => {
        let dados_usuario = getCurrentUser();
        const programaAtual = dados_usuario['ambiente_programa_id'] || this.state.programa_id;

        const isPreCadastro = !!(this.state.programa_dados?.habilitar_pre_cadastro_basico && !this.state.paciente_id);

        const camposConformidade = [];
        const camposPositionBottom = [];
        const conformidadeSlugs = new Set([
            'conformidade-e-direitos-do-paciente',
            'veracidade-dos-dados-fornecidos'
        ]);

        const doencaAtendimentoId = this.state.doenca_id ? parseInt(this.state.doenca_id) : null;
        const valoresAtuais = this.getValoresCamposExtra();

        const bottomFieldSlugs = new Set(
            (this.state.pacientes_campos || [])
                .filter(c => (c.mascara || '').includes('position-bottom'))
                .map(c => c.slug)
        );

        let objCampos = {};

        const camposParaProcessar = this.state.pacientes_campos.filter(campo => {
            const mascara = campo.mascara || '';
            const positionRule = this.parsePositionMask(mascara);
            // Incluir TODOS os campos: vão ser categorizados depois como:
            // 1. position-bottom → rodapé
            // 2. position-after/before → renderizados relativos a campo pai
            // 3. sem posicionamento → renderizados normalmente
            return true;
        });

        console.log('[MASK-DEBUG][FLOW] camposParaProcessar', {
            total: camposParaProcessar.length,
            campos: camposParaProcessar.map(c => ({ slug: c.slug, id: c.id, tipo: c.tipo, mascara: c.mascara }))
        });

        for (let i = 0; i < camposParaProcessar.length; i++) {
            let item = camposParaProcessar[i];

            const campoTemDoencasVinculadas = item.doencas_list && item.doencas_list.length > 0;
            const atendimentoTemDoenca = doencaAtendimentoId !== null;

            if (campoTemDoencasVinculadas && atendimentoTemDoenca) {
                const pertenceDoenca = item.doencas_list.some(d => d.doenca_id === doencaAtendimentoId);
                if (!pertenceDoenca) {
                    continue;
                }
            }

            if (item.mascara && item.mascara.includes('show-on[')) {
                const matchDoenca = item.mascara.match(/show-on\[doenca-id=([^\]]+)\]/);
                if (matchDoenca) {
                    const listaValores = matchDoenca[1].split('|').map(v => v.trim());
                    const doencaAtual = String(this.state.doenca_id || '');
                    if (!listaValores.includes(doencaAtual)) {
                        console.log('[MASK-DEBUG][FLOW] skipped by doenca-id prefilter', {
                            slug: item.slug,
                            doencaAtual,
                            listaValores
                        });
                        continue;
                    }
                }
            }

            item.valor = '';
            for (let j = 0; j < this.state.extra_valores_list.length; j++) {
                let itemValor = this.state.extra_valores_list[j];
                if (itemValor.campo_slug == item.slug) {
                    item.valor = itemValor.valor;
                    item.arquivo = itemValor.arquivo;
                }
            }

            const itemPositionRule = this.parsePositionMask(item.mascara || '');

            if (item.mascara && (item.mascara.includes('position-bottom') || item.mascara.includes('policy-accept'))) {
                if (item.mascara.includes('position-bottom')) {
                    console.log('[MASK-DEBUG][FLOW] pushed to position-bottom', {
                        slug: item.slug,
                        id: item.id,
                        mascara: item.mascara,
                        reason: 'self-position-bottom'
                    });
                    camposPositionBottom.push(item);
                    continue;
                }
            }

            if (itemPositionRule && bottomFieldSlugs.has(itemPositionRule.fieldName)) {
                console.log('[MASK-DEBUG][FLOW] pushed to position-bottom', {
                    slug: item.slug,
                    id: item.id,
                    mascara: item.mascara,
                    reason: `position-${itemPositionRule.type}-of-bottom-field:${itemPositionRule.fieldName}`
                });
                camposPositionBottom.push(item);
                continue;
            }
            
            if (conformidadeSlugs.has(item.slug)) {
                    console.log('[MASK-DEBUG][FLOW] pushed to conformidade', { slug: item.slug, id: item.id });
                    camposConformidade.push(item);
                } else {
                    const sessao = item.programas_list[0].secao || '0_sem_sessao';
                    if (!(sessao in objCampos)) {
                        objCampos[sessao] = [];
                    }
                    console.log('[MASK-DEBUG][FLOW] pushed to section', { slug: item.slug, id: item.id, sessao });
                    objCampos[sessao].push(item);
                }
        }

        console.log('[MASK-DEBUG][FLOW] buckets summary', {
            positionBottom: camposPositionBottom.map(c => c.slug),
            conformidade: camposConformidade.map(c => c.slug),
            secoes: Object.keys(objCampos).reduce((acc, key) => {
                acc[key] = (objCampos[key] || []).map(c => c.slug);
                return acc;
            }, {})
        });

        return (
            <React.Fragment>
                {Object.keys(objCampos).map((nome_secao) => {
                    const camposDaSecao = objCampos[nome_secao] || [];

                    const camposVisiveis = camposDaSecao.filter((campo) => this.shouldShowCampo(campo));

                    // Se nenhum campo da seção for visível, não renderiza nada (nem o título)
                    if (camposVisiveis.length === 0) return null;

                    return (
                        <div key={nome_secao}>
                            {(nome_secao && nome_secao != '0_sem_sessao') && (
                                <h6 className="sessao-campos-extra">
                                    {(tiposSessoesAtendExtra[nome_secao]) ? tiposSessoesAtendExtra[nome_secao] : nome_secao}
                                </h6>
                            )}

                            <Row>
                                {camposVisiveis.map((campo) => {
                                    if (!this.shouldShowCampo(campo)) return null;

                                    if (campo.mascara && campo.mascara.includes('show-on[')) {
                                        const match = campo.mascara.match(/show-on\[([^\]]+)\]/);
                                        if (match && match[1]) {
                                            const [chave, valores] = match[1].split('=');
                                            const listaValores = (valores || '').split('|').map(v => v.trim());
                                            if (chave === 'doenca-id') {
                                                const doencaAtual = String(this.state.doenca_id || '');
                                                if (!listaValores.includes(doencaAtual)) {
                                                    return null;
                                                }
                                            }
                                        }
                                    }

                                    // Lógica do Divisor
                                    const hasDivisor = (campo.mascara || '').includes('divisor');

                                    // Lógica do Policy Accept
                                    const isPolicyAccept = (campo.mascara || '').includes('policy-accept');

                                    if(isPolicyAccept) {
                                         return this.renderPolicyAcceptField(campo, hasDivisor);
                                    }
                                    
                                    if (campo.tipo === 'texto' && (campo.mascara || '').includes('information-field')) {
                                        return (
                                            <React.Fragment key={`info_frag_${campo.id}`}>
                                                {hasDivisor && <Col xs={12}><hr className="my-3" /></Col>}
                                                <Col sm={12} className="mb-3" key={`info_${campo.id}`}>
                                                    <Alert variant="info" className="mb-0" role="status" aria-live="polite">
                                                        {campo.nome ? <div className="fw-semibold mb-1">{campo.nome}</div> : null}
                                                        <div>{campo.descricao}</div>
                                                    </Alert>
                                                </Col>
                                            </React.Fragment>
                                        );
                                    }

                                    const rule = this.parseShowOnMask(campo.mascara || '');
                                    const minL = rule?.minLength || undefined;
                                    const maxL = rule?.maxLength || undefined;

                                    return (
                                        <React.Fragment key={campo.id}>
                                            {hasDivisor && <Col xs={12}><hr className="my-3" /></Col>}
                                            {campo.tipo === 'texto' || campo.tipo === 'area_texto' || campo.tipo === 'data' || campo.tipo === 'selecao' || campo.tipo === 'radio' || campo.tipo === 'numero' || campo.tipo === 'checkbox' ? (
                                                <Col sm={campo.tipo === 'area_texto' ? 12 : 6} className="mb-3">
                                                    <Form.Group>
                                                        <Form.Label>
                                                            {campo.nome}
                                                            {campo.obrigatorio && (
                                                                <>
                                                                    <span className="text-danger ms-1" aria-hidden="true">*</span>
                                                                    <span className="visually-hidden"> obrigatório</span>
                                                                </>
                                                            )}
                                                        </Form.Label>
                                                        {
                                                            (campo.tipo === 'selecao') ? (
                                                                <Form.Control
                                                                    as="select"
                                                                    defaultValue={campo.valor || ''}
                                                                    required={campo.obrigatorio}
                                                                    onChange={(e) => this.handleChangeCampoPacienteExtra(campo.id, e.target.value)}
                                                                >
                                                                    <option value="">Selecione...</option>
                                                                    {campo.opcoes.split('\n').map((opcao, idx) => {
                                                                        const [valor, label] = opcao.split(':');
                                                                        return <option key={idx} value={valor}>{label}</option>;
                                                                    })}
                                                                </Form.Control>
                                                            )
                                                            :
                                                            (campo.tipo === 'texto' && (campo.mascara || '').includes('mask-phone')) ? (
                                                                <Form.Control
                                                                    as={IMaskInput}
                                                                    mask="(00) 00000-0000"
                                                                    defaultValue={campo.valor || ''}
                                                                    required={campo.obrigatorio}
                                                                    onAccept={(value) => this.handleChangeCampoPacienteExtra(campo.id, value)}
                                                                />
                                                            )
                                                            :
                                                            (campo.tipo === 'texto' || campo.tipo === 'data') ? (() => {
                                                                const isDate = campo.tipo === 'data';
                                                                const limits = isDate ? getDateLimits(campo.mascara || '') : {};
                                                                const allowed = isDate ? getAllowedWeekdays(campo.mascara || '') : null;

                                                                return (
                                                                    <Form.Control
                                                                        type={isDate ? 'date' : 'text'}
                                                                        defaultValue={campo.valor || ''}
                                                                        required={campo.obrigatorio}
                                                                        min={isDate ? limits.min || undefined : undefined}
                                                                        max={isDate ? limits.max || undefined : undefined}
                                                                        minLength={minL}
                                                                        maxLength={maxL}
                                                                        onChange={(e) => {
                                                                            let v = e.target.value;

                                                                            if (isDate) {
                                                                                v = clampDate(v, limits);

                                                                                if (v && !isAllowedDateByWeekday(v, allowed)) {
                                                                                    e.target.setCustomValidity('Selecione uma data de segunda a quinta-feira.');
                                                                                    e.target.reportValidity();
                                                                                    return;
                                                                                } else {
                                                                                    e.target.setCustomValidity('');
                                                                                    if (e.target.value !== v) e.target.value = v;
                                                                                }
                                                                            }

                                                                            this.handleChangeCampoPacienteExtra(campo.id, v);
                                                                        }}
                                                                        onBlur={(e) => {
                                                                            if (!isDate) return;
                                                                            const v = e.target.value;
                                                                            if (v && !isAllowedDateByWeekday(v, allowed)) {
                                                                                e.target.setCustomValidity('Selecione uma data de segunda a quinta-feira.');
                                                                                e.target.reportValidity();
                                                                            } else {
                                                                                e.target.setCustomValidity('');
                                                                            }
                                                                        }}
                                                                    />
                                                                );
                                                            })()
                                                            :
                                                            (campo.tipo === 'numero') ? (
                                                                <Form.Control
                                                                    type="number"
                                                                    value={this.state.valoresCamposExtraPaciente?.[campo.id] ?? (campo.valor || '')}
                                                                    required={campo.obrigatorio}
                                                                    onChange={(e) => this.handleChangeCampoPacienteExtra(campo.id, e)}
                                                                />
                                                            )
                                                            :
                                                            (campo.tipo === 'checkbox') ? (
                                                                <div>
                                                                    {(campo.opcoes || '').split('\n').map((opcao, idx) => {
                                                                        const [valor, label] = opcao.split(':');
                                                                        return (
                                                                            <Form.Check
                                                                                key={`checkbox_${campo.id}_${idx}`}
                                                                                type="checkbox"
                                                                                label={label || valor}
                                                                                value={valor}
                                                                                checked={(this.state.valoresCamposExtraPaciente?.[campo.id] || '').split(',').includes(valor)}
                                                                                onChange={(e) => this.handleChangeCampoPacienteExtra(campo.id, e)}
                                                                            />
                                                                        );
                                                                    })}
                                                                </div>
                                                            )
                                                            :
                                                            (campo.tipo === 'radio') ? (
                                                                <div>
                                                                    {campo.opcoes.split('\n').map((opcao, indexO) => {
                                                                        const [valorRadioRaw, labelRadioRaw] = opcao.split(':');
                                                                        const valorRadio = (valorRadioRaw || '').trim();
                                                                        const labelRadio = (labelRadioRaw || valorRadio).trim();

                                                                        const valorAtual = (this.state.valoresCamposExtraPaciente?.[campo.id] ?? campo.valor ?? '').toString();

                                                                        return (
                                                                            <Form.Check
                                                                                inline
                                                                                type="radio"
                                                                                label={labelRadio}
                                                                                key={`radio_${campo.id}_opcao_${indexO}`}
                                                                                id={`radio_${campo.id}_opcao_${indexO}`}
                                                                                value={valorRadio}
                                                                                onChange={(e) => this.handleChangeCampoPacienteExtra(campo.id, e.target.value)}
                                                                                checked={valorAtual === valorRadio}
                                                                            />
                                                                        );
                                                                    })}
                                                                </div>
                                                            )
                                                            :
                                                            (
                                                                <Form.Control
                                                                    as={campo.tipo === 'area_texto' ? 'textarea' : 'text'}
                                                                    defaultValue={campo.valor || ''}
                                                                    required={campo.obrigatorio}
                                                                    className={campo.tipo === 'area_texto' ? 'custom-textarea2' : ''}
                                                                    minLength={minL}
                                                                    maxLength={maxL}
                                                                    onChange={(e) => this.handleChangeCampoPacienteExtra(campo.id, e.target.value)}
                                                                />
                                                            )
                                                        }
                                                        {campo.descricao && (
                                                            <Form.Text className="text-muted" style={{ fontSize: '0.9em' }}>
                                                                {campo.descricao}
                                                            </Form.Text>
                                                        )}
                                                    </Form.Group>

                                                    {campo.programas_list &&
                                                        campo.programas_list.some((programa) => {
                                                            const isMatch =
                                                                parseInt(programa.programa_id, 10) === parseInt(programaAtual, 10) &&
                                                                programa.gerar_historico &&
                                                                this.state.paciente_id;
                                                            return isMatch;
                                                        }) && (
                                                            <Button
                                                                variant="link"
                                                                size="sm"
                                                                className="p-0 mt-1"
                                                                onClick={() => this.abrirModalHistorico(campo.id, campo.nome)}
                                                            >
                                                                <small>Ver histórico</small>
                                                            </Button>
                                                        )
                                                    }
                                                </Col>
                                            ) : null}

                                            {campo.tipo === 'arquivo' && (
                                                <Col sm={6} className="mb-3">
                                                    <Form.Group>
                                                        <Form.Label>
                                                            {campo.nome}
                                                            {campo.obrigatorio && (
                                                                <>
                                                                    <span className="text-danger ms-1" aria-hidden="true">*</span>
                                                                    <span className="visually-hidden"> obrigatório</span>
                                                                </>
                                                            )}
                                                        </Form.Label>
                                                        <Form.Control
                                                            type="file"
                                                            required={campo.obrigatorio && !campo.arquivo}
                                                            onChange={(e) => this.handleChangeCampoPacienteExtra(campo.id, e)}
                                                        />
                                                        {campo.descricao && (
                                                            <Form.Text className="text-muted">{campo.descricao}</Form.Text>
                                                        )}
                                                    </Form.Group>
                                                    {campo.arquivo && (
                                                        <a
                                                            href={campo.arquivo}
                                                            target="_blank"
                                                            className="btn btn-link btn-sm p-0 mt-1" rel="noreferrer"
                                                        >
                                                            Ver Arquivo
                                                        </a>
                                                    )}
                                                </Col>
                                            )}

                                            {this.renderAlertasCondicionais(campo, valoresAtuais)}
                                        </React.Fragment>
                                    );
                                })}
                            </Row>
                        </div>
                    );
                })}

                {camposConformidade.length > 0 && (
                    <div className="conformidade-section mt-4">
                        <hr />
                        <p style={{ fontSize: '0.9em' }}>
                            Para garantir a transparência e a conformidade com normas éticas e legais,
                            é necessário confirmar que o paciente foi devidamente informado e
                            autorizou sua participação no Programa Raros em Foco. Solicitamos que
                            declare, de forma expressa, que o paciente recebeu todas as informações
                            relevantes e consentiu com sua indicação ao Programa. Essa confirmação é
                            essencial para que possamos prosseguir com a análise e assegurar a segurança e o respeito aos direitos do paciente.
                        </p>
                        <Row>
                            {camposConformidade.map((campo) => {
                                return (
                                    <React.Fragment key={campo.id}>
                                        {campo.tipo === 'checkbox' ? (
                                            <Col sm={12} className="mb-3">
                                                <Form.Group>
                                                    <Form.Label>
                                                        {campo.nome}
                                                        {campo.obrigatorio && (
                                                            <>
                                                                <span className="text-danger ms-1" aria-hidden="true">*</span>
                                                                <span className="visually-hidden"> obrigatório</span>
                                                            </>
                                                        )}
                                                    </Form.Label>
                                                    <div>
                                                        {(campo.opcoes || '').split('\n').map((opcao, idx) => {
                                                            const [valor, labelOriginal] = opcao.split(':');
                                                            const valoresSelecionados = (this.state.valoresCamposExtraPaciente?.[campo.id] || campo.valor || '').split(',');

                                                            let labelExibicao = labelOriginal || valor;

                                                            if (campo.slug === 'conformidade-e-direitos-do-paciente') {
                                                                labelExibicao = "Declaro que o paciente está ciente dos dados pessoais e sensíveis fornecidos neste pré-cadastro, concorda com seu compartilhamento e tratamento, e deseja receber contato do Programa de Suporte ao Diagnóstico Raros em Foco para efetivar sua inscrição e participação.";
                                                            } else if (campo.slug === 'veracidade-dos-dados-fornecidos') {
                                                                labelExibicao = "Declaro também que estou ciente de que sou o único responsável pela veracidade e exatidão dos dados fornecidos, bem como pela obtenção do consentimento do paciente e pela prestação de informações claras e transparentes sobre este pré-cadastro.";
                                                            }

                                                            return (
                                                                <Form.Check
                                                                    key={`checkbox_${campo.id}_${idx}`}
                                                                    type="checkbox"
                                                                    label={labelExibicao}
                                                                    value={valor}
                                                                    checked={valoresSelecionados.includes(valor)}
                                                                    onChange={(e) => this.handleChangeCampoPacienteExtra(campo.id, e)}
                                                                    required={campo.obrigatorio}
                                                                    feedback="Você deve aceitar este termo para continuar."
                                                                    feedbackType="invalid"
                                                                    style={{ whiteSpace: 'normal', textAlign: 'justify' }}
                                                                />
                                                            );
                                                        })}
                                                    </div>
                                                    {campo.descricao && (
                                                        <Form.Text className="text-muted" style={{ fontSize: '0.9em' }}>
                                                            {campo.descricao}
                                                        </Form.Text>
                                                    )}
                                                </Form.Group>
                                            </Col>
                                        ) : null}
                                    </React.Fragment>
                                );
                            })}
                        </Row>
                    </div>
                )}

                {/* Render field with position-bottom - with full mask support */}
                {camposPositionBottom.length > 0 && (
                     <div className="position-bottom-section mt-4">
                        <Row>
                            {(() => {
                                const camposBottomVisiveis = camposPositionBottom.filter(campo => this.shouldShowCampo(campo));
                                const { camposSemPosicao: camposBottomRaiz, mapaPosicoes: mapaPosicoesBottom } = this.organizarCamposPorPosicao(camposBottomVisiveis);

                                console.log('[MASK-DEBUG][BOTTOM] render block', {
                                    allBottom: camposPositionBottom.map(c => c.slug),
                                    visiveis: camposBottomVisiveis.map(c => c.slug),
                                    raiz: camposBottomRaiz.map(c => c.slug),
                                    mapaPosicoesBottom
                                });

                                return camposBottomRaiz.map(campo => {
                                    const hasDivisor = (campo.mascara || '').includes('divisor');
                                    const isPolicyAccept = (campo.mascara || '').includes('policy-accept') && (campo.tipo === 'checkbox' || campo.tipo === 'radio');

                                    console.log('[MASK-DEBUG][BOTTOM] rendering root campo', {
                                        slug: campo.slug,
                                        tipo: campo.tipo,
                                        isPolicyAccept,
                                        hasDivisor
                                    });

                                    if (isPolicyAccept) {
                                        return this.renderPolicyAcceptField(campo, hasDivisor, programaAtual, mapaPosicoesBottom);
                                    }

                                    return this.renderCampoPersonalizadoInline(campo, programaAtual, mapaPosicoesBottom);
                                });
                            })()}
                        </Row>
                     </div>
                )}
            </React.Fragment>
        );
    }

    carregaCamposExtraPaciente = async () => {
        console.log("Carrega campos extras");
        let dados_usuario = getCurrentUser();
        const programa_id = (this.state.programa_id) ? this.state.programa_id : dados_usuario['ambiente_programa_id'];
        if (programa_id) {
            try {
                const response = await api.get(`/pessoas/beneficiarios/campos/?programa_id=${programa_id}&order_by=asc&order=id`);
                this.setState({ pacientes_campos: response.data.results });
    
            } catch (error) {
                console.error('Erro ao carregar campos do paciente:', error);
                Sentry.captureException('Erro ao carregar campos do paciente:', error);
            }
        }
    };

    // Normaliza string numérica pt-BR -> número JS
    toNumber = (v) => {
        if (v === null || v === undefined) return NaN;
        if (typeof v === 'number') return v;
        const s = String(v).trim().replace(/\./g, '').replace(',', '.');
        const n = parseFloat(s);
        return Number.isFinite(n) ? n : NaN;
    };

    
    // Lê uma máscara do tipo: "auto:imc altura=<slug_altura> peso=<slug_peso> unidade=cm"
    // unidade pode ser "cm" (default) ou "m"
    parseImcMask = (mask) => {
        if (!mask || typeof mask !== 'string') return null;

        // pega só o trecho do auto:imc até ; ou quebra de linha
        const m = mask.match(/auto:imc\b([^\n\r;]*)/i);
        if (!m) return null;

        const params = m[1] || '';
        const alturaMatch  = params.match(/altura=([a-z0-9_\-]+)/i);
        const pesoMatch    = params.match(/peso=([a-z0-9_\-]+)/i);
        const unidadeMatch = params.match(/unidade=(cm|m)/i);

        if (!alturaMatch || !pesoMatch) return null;
        return {
            alturaSlug: alturaMatch[1],
            pesoSlug:   pesoMatch[1],
            unidade:    (unidadeMatch ? unidadeMatch[1] : 'cm').toLowerCase()
        };
    };

    // Computa IMC: peso(kg) / altura(m)^2
    computeImc = (pesoKg, alturaValor, unidade='cm') => {
        const kg = this.toNumber(pesoKg);
        let m;
        if (unidade === 'm') {
            m = this.toNumber(alturaValor);
        } else {
            // cm -> m
            m = this.toNumber(alturaValor) / 100;
        }
        if (!Number.isFinite(kg) || !Number.isFinite(m) || m <= 0) return '';
        const imc = kg / (m * m);
        // 2 casas decimais
        return imc.toFixed(2);
    };

    // Dado um slug, acha o ID do campo no array pacientes_campos
    getCampoIdBySlug = (slug) => {
        const item = (this.state.pacientes_campos || []).find(c => c.slug === slug);
        return item ? item.id : null;
    };

    // Recalcula campos derivados cujo "mascara" peça IMC.
    maybeRecalculateDerivedFields = () => {
        const campos = this.state.pacientes_campos || [];

        const camposImc = campos
            .map(c => ({ campo: c, maskCfg: this.parseImcMask(c.mascara) }))
            .filter(x => !!x.maskCfg);

        if (camposImc.length === 0) return;

        const mapSlugToId = {};
        campos.forEach(c => { mapSlugToId[c.slug] = c.id; });

        const novos = { ...(this.state.valoresCamposExtraPaciente || {}) };
        let houveMudanca = false;

        camposImc.forEach(({ campo, maskCfg }) => {
            const alturaId = mapSlugToId[maskCfg.alturaSlug];
            const pesoId   = mapSlugToId[maskCfg.pesoSlug];
            if (!alturaId || !pesoId) return;

            // >>>>> aqui usamos o fallback inteligente <<<<<
            const alturaVal = this.getCampoValorAtualById(alturaId);
            const pesoVal   = this.getCampoValorAtualById(pesoId);

            const imcNovo = this.computeImc(pesoVal, alturaVal, maskCfg.unidade);
            const atual = novos[campo.id] ?? '';

            if (imcNovo !== atual) {
            novos[campo.id] = imcNovo;
            houveMudanca = true;
            }
        });

        if (houveMudanca) {
            this.setState({ valoresCamposExtraPaciente: novos });
        }
    };  

    getCampoValorAtualById = (id) => {
        const fromState = this.state?.valoresCamposExtraPaciente?.[id];
        if (fromState !== undefined && fromState !== null && String(fromState) !== '') {
            return fromState;
        }

        const campo = (this.state.pacientes_campos || []).find(c => c.id === id);
        if (campo && campo.valor !== undefined && campo.valor !== null && String(campo.valor) !== '') {
            return campo.valor;
        }

        if (campo && campo.slug && Array.isArray(this.state.extra_valores_list)) {
            const hit = this.state.extra_valores_list.find(v => v.campo_slug === campo.slug);
            if (hit && String(hit.valor) !== '') return hit.valor;
        }

        return '';
    };

    coercePrimitive = (v) => {
        if (typeof v === 'string') {
            const s = v.trim();
            if (/^(true|false)$/i.test(s)) return /^true$/i.test(s);
            if (/^-?\d+(\.\d+)?$/.test(s)) return parseFloat(s);
        }
        return v;
    };

    calculateAge = (birthDateString) => {
        if (!birthDateString) return null;
        const birthDate = new Date(birthDateString + 'T00:00:00');
        const today = new Date();
        
        let age = today.getFullYear() - birthDate.getFullYear();
        const m = today.getMonth() - birthDate.getMonth();
        
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }
        return age;
    };

    parseShowOnMask = (mask) => {
        if (!mask || typeof mask !== 'string') return null;

        console.log('[MASK-DEBUG][SHOW-ON][parse] start', { mask });

        const dbg = (stage, payload) => {
            console.log('[MASK-DEBUG][SHOW-ON][parse]', { stage, ...payload });
            return payload.result;
        };

        // min/max em qualquer lugar
        let minLength = null, maxLength = null;
        const minMatch = mask.match(/(?:^|\|)\s*minLength\s*=\s*(\d+)/i);
        const maxMatch = mask.match(/(?:^|\|)\s*maxLength\s*=\s*(\d+)/i);
        if (minMatch) minLength = parseInt(minMatch[1], 10);
        if (maxMatch) maxLength = parseInt(maxMatch[1], 10);

        // NOVO: flag para liberar no pré-cadastro (também libera se context=new ou context=both)
        const preAllow = /(?:^|\|)\s*(pre(?:-cadastro)?|pre-allow|context=new|context=both)(?:\s*=\s*true)?\s*(?:\||$)/i.test(mask);

        // regra principal show-on[...]
        const m = mask.match(/show-on\[(.*?)\]/i);
        if (!m) {
            // sem show-on, ainda assim retornamos as validações e o preAllow
            if (minLength != null || maxLength != null || preAllow) {
            return dbg('no-show-on-always', { result: { op: 'always', minLength, maxLength, preAllow } });
            }
            return dbg('no-show-on-none', { result: { op: 'none', preAllow } }); // sem nada específico
        }

        const body = m[1].trim();

        // formato simples: slug=valor / slug!=valor
        const simple = !body.includes('|') && body.match(/^([a-z0-9_]+)\s*(!=|=)\s*(.+)$/i);
        if (simple) {
            const key = simple[1].trim();
            const opSymbol = simple[2] === '!=' ? 'neq' : 'eq';
            const values = simple[3].trim().split(',').map(s => this._normalize(s)).filter(Boolean);
            return dbg('simple', { result: { source: 'extra', key, op: opSymbol, values, minLength, maxLength, preAllow } });
        }

        // avançado com pares '|'
        const pairs = body.split('|').map(p => p.trim()).filter(Boolean);
        const cfg = {};
        pairs.forEach((p) => {
            if (/^!?\s*has$/i.test(p)) { cfg.__hasFlag = p.startsWith('!') ? 'notpresent' : 'present'; return; }
            const [k, ...rest] = p.split('=');
            if (!k) return;
            cfg[k.trim().toLowerCase()] = rest.length ? rest.join('=').trim() : '';
        });

        // Extrai calc expr
        const calcExpr = cfg['calc']; 

        const stateKey  = cfg['campo_paciente'] || cfg['state_key'] || cfg['state'];
        const extraSlug = cfg['campo_extra'] || cfg['extra_slug'] || cfg['extra'];
        let valorRaw    = (cfg['campo_valor'] !== undefined ? cfg['campo_valor'] : cfg['valor']);

        if (!stateKey && !extraSlug) {
            return dbg('no-source', { result: { op: 'always', minLength, maxLength, preAllow } });
        }

        const source = stateKey ? 'state' : 'extra';
        const key    = stateKey || extraSlug;

        if (calcExpr) {
            return dbg('calc', { result: { source, key, op: 'calc', calcExpr, minLength, maxLength, preAllow } });
        }

        if (cfg.__hasFlag === 'present')    return dbg('has-present', { result: { source, key, op: 'present',    minLength, maxLength, preAllow } });
        if (cfg.__hasFlag === 'notpresent') return dbg('has-notpresent', { result: { source, key, op: 'notpresent', minLength, maxLength, preAllow } });

        let op = 'eq';
        if (String(valorRaw || '').startsWith('!=')) { op = 'neq'; valorRaw = String(valorRaw).slice(2).trim(); }
        if (valorRaw === '*' || valorRaw === '?')     return dbg('wildcard', { result: { source, key, op: op === 'neq' ? 'notpresent' : 'present', minLength, maxLength, preAllow } });

        const values = String(valorRaw || '').split(',').map(s => this._normalize(s)).filter(Boolean);
        return dbg('advanced', { result: { source, key, op, values, minLength, maxLength, preAllow } });
    };

    looseEqual = (a, b) => {
        // normaliza booleans/números vindos como string
        const A = this.coercePrimitive(a);
        const B = this.coercePrimitive(b);

        // Checkbox pode vir "a,b,c" (string) — se B também é string simples, testamos inclusão
        if (typeof A === 'string' && A.includes(',') && typeof B === 'string') {
            return A.split(',').map(s => s.trim()).includes(B.trim());
        }

        return A === B;
    };

    // Retorna true/false se o campo deve aparecer (agora com op: present/notpresent/eq/neq)
    shouldShowCampo = (campo) => {
        console.log('[MASK-DEBUG][SHOW] start', {
            id: campo?.id,
            slug: campo?.slug,
            tipo: campo?.tipo,
            mascara: campo?.mascara
        });

        // Verifica regra de doenca-id
        if (campo.mascara && campo.mascara.includes('show-on[')) {
            const match = campo.mascara.match(/show-on\[([^\]]+)\]/);
            if (match && match[1]) {
                const [chave, valores] = match[1].split('=');
                const listaValores = (valores || '').split('|').map(v => v.trim());
                if (chave === 'doenca-id') {
                    const doencaAtual = String(this.state.doenca_id || '');
                    if (!listaValores.includes(doencaAtual)) {
                        console.log('[MASK-DEBUG][SHOW] blocked by doenca-id', {
                            slug: campo?.slug,
                            doencaAtual,
                            listaValores
                        });
                        return false; // campo não deve aparecer
                    }
                }
            }
        }
        
        // Detectar múltiplos blocos show-on[...] para lógica AND
        const showOnPattern = /show-on\[([^\]]+)\]/gi;
        const showOnMatches = Array.from(campo.mascara?.matchAll(showOnPattern) || []);
        
        // Está em pré-cadastro?
        const isPreCadastro = !!(this.state.programa_dados?.habilitar_pre_cadastro_basico && !this.state.paciente_id);

        // Validação show-on-any
        const hasShowOnAny = /show-on-any\[/i.test(campo.mascara || '');
        if (hasShowOnAny) {
            // Se é information-field com show-on-any, usa _evalShowOn
            if (!this._evalShowOn(campo.mascara || '')) return false;
        }

        // Calcula idade a partir de uma data (YYYY-MM-DD)
        const calculateAge = (birthDateString) => {
            if (!birthDateString) return null;
            const birthDate = new Date(birthDateString + 'T00:00:00'); // Garante data local
            const today = new Date();
            
            let age = today.getFullYear() - birthDate.getFullYear();
            const m = today.getMonth() - birthDate.getMonth();
            
            if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
                age--;
            }
            return age;
        };

        // Avalia show-on (igual você já fazia)
        const evalRule = (r) => {
            if (!r || r.op === 'none') return true;
            if (r.op === 'always') return true;

            // Lógica de Cálculo (Idade)
            if (r.op === 'calc') {
                let currentRaw;
                if (r.source === 'state') {
                    currentRaw = this.state?.[r.key];
                } else if (r.source === 'extra') {
                    const id = this.getCampoIdBySlug(r.key);
                    if (!id) {
                        console.log('[MASK-DEBUG][SHOW][eval] calc source slug not found', {
                            fieldSlug: campo?.slug,
                            sourceSlug: r.key
                        });
                        return false;
                    }
                    currentRaw = this.getCampoValorAtualById(id);
                }

                if (!currentRaw) {
                    console.log('[MASK-DEBUG][SHOW][eval] calc empty value', {
                        fieldSlug: campo?.slug,
                        sourceSlug: r.key
                    });
                    return false;
                }

                // Suporte inicial para idade (calc=age-gt-18)
                if (r.calcExpr && r.calcExpr.startsWith('age-')) {
                    const age = calculateAge(currentRaw);
                    if (age === null) return false;

                    const parts = r.calcExpr.split('-'); // ['age', 'gt', '18']
                    if (parts.length === 3) {
                        const op = parts[1];
                        const targetAge = parseInt(parts[2], 10);
                        
                        switch(op) {
                            case 'gt': return age > targetAge;
                            case 'gte': return age >= targetAge;
                            case 'lt': return age < targetAge;
                            case 'lte': return age <= targetAge;
                            case 'eq': return age === targetAge;
                            default: return false;
                        }
                    }
                }
                return false;
            }

            let currentRaw;
            if (r.source === 'state') {
                currentRaw = this.state?.[r.key];
            } else if (r.source === 'extra') {
                const id = this.getCampoIdBySlug(r.key);
                if (!id) {
                    console.log('[MASK-DEBUG][SHOW][eval] source slug not found', {
                        fieldSlug: campo?.slug,
                        sourceSlug: r.key
                    });
                    return false;
                }
                currentRaw = this.getCampoValorAtualById(id);
            }

            const raw = (currentRaw ?? '').toString().trim();
            const cur = this._normalize(raw);

            console.log('[MASK-DEBUG][SHOW][eval] normalized', {
                fieldSlug: campo?.slug,
                rule: r,
                currentRaw,
                raw,
                cur
            });

            switch (r.op) {
                case 'present':    return raw.length > 0;
                case 'notpresent': return raw.length === 0;
                case 'eq':
                    if (typeof raw === 'string' && raw.includes(',') && r.values?.length === 1) {
                        return raw.split(',').map(s => this._normalize(s)).includes(r.values[0]);
                    }
                    return (r.values || []).includes(cur);
                case 'neq':
                    if (typeof raw === 'string' && raw.includes(',') && r.values?.length === 1) {
                        return !raw.split(',').map(s => this._normalize(s)).includes(r.values[0]);
                    }
                    return !(r.values || []).includes(cur);
                default:
                    return true;
            }
        };

        // Se houver múltiplos show-on[...], avaliar TODOS com AND logic
        if (showOnMatches.length > 1) {
            // Para cada show-on[...], criar uma máscara temporária e avaliar
            for (const match of showOnMatches) {
                const tempMask = `show-on[${match[1]}]`;
                const rule = this.parseShowOnMask(tempMask);
                if (!evalRule(rule)) {
                    console.log('[MASK-DEBUG][SHOW] blocked by multi-show-on rule', {
                        fieldSlug: campo?.slug,
                        tempMask,
                        rule
                    });
                    return false; // Se QUALQUER condição falhar, não mostra
                }
            }
            
            // Todas as condições passaram, verificar contexto
            const contextoPermitido = this.parseContextMask(campo.mascara || '');
            const isNovoCadastro = !this.state.paciente_id;
            
            if (contextoPermitido === 'new' && !isNovoCadastro) {
                console.log('[MASK-DEBUG][SHOW] blocked by context=new', { fieldSlug: campo?.slug, isNovoCadastro });
                return false;
            }
            if (contextoPermitido === 'edit' && isNovoCadastro) {
                console.log('[MASK-DEBUG][SHOW] blocked by context=edit', { fieldSlug: campo?.slug, isNovoCadastro });
                return false;
            }
            
            return true; // Todas as condições AND passaram
        }

        // Lógica original para 1 ou 0 show-on
        const rule = this.parseShowOnMask(campo.mascara || '');

        // 1) Se é pré-cadastro: só mostra se tiver flag de pré e (se houver show-on) a regra bater
        if (isPreCadastro) {
            const preAllow = !!rule?.preAllow;
            const hasShowOn = /show-on\[/i.test(campo.mascara || '');
            if (!preAllow) {
                console.log('[MASK-DEBUG][SHOW] blocked in pre-cadastro: preAllow=false', { fieldSlug: campo?.slug });
                return false;
            }
            
            const contextoPermitido = this.parseContextMask(campo.mascara || '');
            const isNovoCadastro = !this.state.paciente_id;
            
            if (contextoPermitido === 'new' && !isNovoCadastro) {
                console.log('[MASK-DEBUG][SHOW] blocked by context=new (pre)', { fieldSlug: campo?.slug, isNovoCadastro });
                return false;
            }
            if (contextoPermitido === 'edit' && isNovoCadastro) {
                console.log('[MASK-DEBUG][SHOW] blocked by context=edit (pre)', { fieldSlug: campo?.slug, isNovoCadastro });
                return false;
            }
            
            const resultPre = hasShowOn ? evalRule(rule) : true;
            console.log('[MASK-DEBUG][SHOW] pre-cadastro result', { fieldSlug: campo?.slug, resultPre, hasShowOn, rule });
            return resultPre;
        }

        const contextoPermitido = this.parseContextMask(campo.mascara || '');
        const isNovoCadastro = !this.state.paciente_id;
        
        if (contextoPermitido === 'new' && !isNovoCadastro) {
            console.log('[MASK-DEBUG][SHOW] blocked by context=new', { fieldSlug: campo?.slug, isNovoCadastro });
            return false;
        }
        
        if (contextoPermitido === 'edit' && isNovoCadastro) {
            console.log('[MASK-DEBUG][SHOW] blocked by context=edit', { fieldSlug: campo?.slug, isNovoCadastro });
            return false;
        }

        const hasShowOn = /show-on\[/i.test(campo.mascara || '');
        const finalResult = hasShowOn ? evalRule(rule) : true;
        console.log('[MASK-DEBUG][SHOW] final', { fieldSlug: campo?.slug, hasShowOn, rule, finalResult });
        return finalResult;
    };


    getValorCampoExtraBySlug = (slug) => {
        try {
            const campo = (this.state.pacientes_campos || []).find(c => c.slug === slug);
            if (!campo) return null;

            const valState = this.state.valoresCamposExtraPaciente?.[campo.id];
            if (valState !== undefined && valState !== null) return valState;

            const fromList = (this.state.extra_valores_list || []).find(v => v.campo_slug === slug);
            if (fromList && fromList.valor !== undefined) return fromList.valor;

            return campo.valor ?? null;
        } catch {
            return null;
        }
    };

    // Normaliza para comparação (string, trim, lower)
    _normalize = (v) => {
        if (typeof v === 'boolean') return v ? 'true' : 'false';
        return (v ?? '').toString().trim().toLowerCase();
    };

    // Parsea show-on[...] ou show-on-any[...]
    // Retorna { mode: 'all' | 'any', conditions: [{slug, op: 'eq'|'neq', values: ['sim','talvez']}, ...] }
    _parseShowOnFromMask = (maskStr = '') => {
        const m = maskStr.match(/show-on(?:-(any|all))?\[([^\]]+)\]/i);
        if (!m) return null;
        const mode = (m[1] || 'all').toLowerCase(); // default AND
        const raw = m[2];

        const conditions = raw
            .split(',')
            .map(s => s.trim())
            .filter(Boolean)
            .map(cond => {
            // suporta != e =
            let op = 'eq';
            let [lhs, rhs] = cond.split('!=');
            if (rhs === undefined) {
                [lhs, rhs] = cond.split('=');
                op = 'eq';
            } else {
                op = 'neq';
            }
            const slug = (lhs || '').trim();
            const values = (rhs || '').split('|').map(v => this._normalize(v));
            return { slug, op, values };
            });

        return { mode: (mode === 'any' ? 'any' : 'all'), conditions };
    };

    // Avalia se deve mostrar com base na máscara
    _evalShowOn = (maskStr = '') => {
        const parsed = this._parseShowOnFromMask(maskStr);
        if (!parsed) return true; // sem show-on => exibe
        const { mode, conditions } = parsed;

        const results = conditions.map(({ slug, op, values }) => {
            const current = this._normalize(this.getValorCampoExtraBySlug(slug));
            const inList = values.includes(current);
            return op === 'eq' ? inList : !inList;
        });

        return mode === 'any' ? results.some(Boolean) : results.every(Boolean);
    };

    handleArquivoCuidador = (e) => {
        const file = e.target.files && e.target.files[0] ? e.target.files[0] : null;
        this.setState({
            cuidador_documento_file: file,
            cuidadorDocumentoHelper: ""
        });
    };

    verificarAlertasCondicionais = (prevState) => {
        const dadosUsuario = getCurrentUser?.() || {};
        const ehPrestadorMedico =
            dadosUsuario.tipo_usuario === 'prestador' &&
            dadosUsuario.prestador_categoria === 'medicos';

        if (!ehPrestadorMedico) {
            return;
        }

        const valoresAtuais = this.getValoresCamposExtra();
        const valoresAnteriores = this.getValoresCamposExtraFromState(prevState);
        const MySwal = withReactContent(Swal);

        // Helper para verificar se deve mostrar o alerta
        const deveExibirAlerta = (slug, valorTrigger) => {
            const valorAtual = valoresAtuais[slug];
            const valorAnterior = valoresAnteriores[slug];
            const alertaKey = `${slug}_${valorTrigger}`;
            
            // Só exibe se: valor atual é o trigger, valor anterior era diferente, e ainda não exibiu
            if (valorAtual === valorTrigger && 
                valorAnterior !== valorTrigger && 
                !this.state.alertasExibidos.has(alertaKey)) {
                
                this.setState(prev => ({
                    alertasExibidos: new Set([...prev.alertasExibidos, alertaKey])
                }));
                return true;
            }
            return false;
        };

        // Verifica cada condição que deve disparar o SweetAlert

        // 1. Solicitação Amônia = "Não"
        if (deveExibirAlerta('solicita_exame_dosagem_amonia', 'Não')) {
            MySwal.fire({
                icon: 'info',
                title: 'Atenção',
                text: 'Um profissional do programa entrará em contato em até 24 horas úteis após a conclusão da solicitação.',
                confirmButtonText: 'OK',
                confirmButtonColor: '#3085d6',
            });
            return; // evita múltiplos alertas simultâneos
        }

        // 2. Repetição exame porfiria = "Não"
        if (deveExibirAlerta('repeticao_exame_porfiria', 'Não')) {
            MySwal.fire({
                icon: 'info',
                title: 'Atenção',
                text: 'Um profissional do programa entrará em contato em até 24 horas úteis após a conclusão da solicitação.',
                confirmButtonText: 'OK',
                confirmButtonColor: '#3085d6',
            });
            return;
        }

        // 3. Diagnóstico de acromegalia = "Não"
        if (deveExibirAlerta('diagnostico-de-acromegalia', 'Não')) {
            MySwal.fire({
                icon: 'info',
                title: 'Atenção',
                text: 'Um profissional do programa entrará em contato em até 24 horas úteis após a conclusão da solicitação.',
                confirmButtonText: 'OK',
                confirmButtonColor: '#3085d6',
            });
            return;
        }
    };

    // Adicione este helper para pegar valores do state anterior:
    getValoresCamposExtraFromState = (stateObj) => {
        const valores = {};
        for (const campo of (stateObj.pacientes_campos || [])) {
            const valorAtual = stateObj.valoresCamposExtraPaciente?.[campo.id];
            if (valorAtual !== undefined) {
                valores[campo.slug] = valorAtual;
            } else {
                // Tenta pegar do extra_valores_list
                const fromList = (stateObj.extra_valores_list || []).find(v => v.campo_slug === campo.slug);
                valores[campo.slug] = fromList?.valor || campo.valor || '';
            }
        }
        return valores;
    };
    // Parsea position-after=campo ou position-before=campo da máscara
    parsePositionMask = (mask) => {
        if (!mask || typeof mask !== 'string') return null;
        
        const afterMatch = mask.match(/position-after=([a-z0-9_-]+)/i);
        const beforeMatch = mask.match(/position-before=([a-z0-9_-]+)/i);
        
        if (afterMatch) {
            console.log('[MASK-DEBUG][POSITION] parsed after', { mask, fieldName: afterMatch[1] });
            return { type: 'after', fieldName: afterMatch[1] };
        }
        if (beforeMatch) {
            console.log('[MASK-DEBUG][POSITION] parsed before', { mask, fieldName: beforeMatch[1] });
            return { type: 'before', fieldName: beforeMatch[1] };
        }
        
        return null;
    };

    // Parsea context=new|edit|both da máscara
    parseContextMask = (mask) => {
        if (!mask || typeof mask !== 'string') return null;
        
        const contextMatch = mask.match(/context=(new|edit|both)/i);
        
        if (contextMatch) {
            return contextMatch[1].toLowerCase();
        }
        
        return null; // Sem especificação = ambos por padrão
    };

    // Organiza campos personalizados por posicionamento
    organizarCamposPorPosicao = (campos) => {
        const camposComPosicao = [];
        const camposSemPosicao = [];
        const mapaPosicoes = {}; // { fieldName: { before: [], after: [] } }

        console.log('[MASK-DEBUG][POSITION] organize start', {
            total: campos?.length || 0,
            slugs: (campos || []).map(c => c.slug)
        });
        
        campos.forEach(campo => {
            const positionRule = this.parsePositionMask(campo.mascara || '');
            
            if (positionRule) {
                console.log('[MASK-DEBUG][POSITION] mapped', {
                    slug: campo.slug,
                    type: positionRule.type,
                    fieldName: positionRule.fieldName
                });
                camposComPosicao.push({ ...campo, positionRule });
                
                const { fieldName, type } = positionRule;
                if (!mapaPosicoes[fieldName]) {
                    mapaPosicoes[fieldName] = { before: [], after: [] };
                }
                mapaPosicoes[fieldName][type].push(campo);
            } else {
                camposSemPosicao.push(campo);
            }
        });

        console.log('[MASK-DEBUG][POSITION] organize done', {
            comPosicao: camposComPosicao.map(c => c.slug),
            semPosicao: camposSemPosicao.map(c => c.slug),
            mapaPosicoes
        });
        
        return { camposComPosicao, camposSemPosicao, mapaPosicoes };
    };

    // Renderiza um campo fixo com campos personalizados posicionados dinamicamente
    renderFieldWithPositionedFields = (fieldName, fieldJSX, mapaPosicoes, programaAtual) => {
        return (
            <>
                {/* Campos personalizados ANTES do campo */}
                {mapaPosicoes[fieldName]?.before?.map(campo => 
                    this.renderCampoPersonalizadoInline(campo, programaAtual, mapaPosicoes)
                )}
                
                {/* Campo fixo */}
                {fieldJSX}
                
                {/* Campos personalizados DEPOIS do campo */}
                {mapaPosicoes[fieldName]?.after?.map(campo => 
                    this.renderCampoPersonalizadoInline(campo, programaAtual, mapaPosicoes)
                )}
            </>
        );
    };

    // Renderiza um campo personalizado inline (para usar em posicionamento)
    // Suporta posicionamento recursivo: campos podem estar posicionados em relação a outros campos personalizados
    renderCampoPersonalizadoInline = (campo, programaAtual, mapaPosicoes = null) => {
        console.log('[MASK-DEBUG][INLINE] start', {
            slug: campo?.slug,
            id: campo?.id,
            tipo: campo?.tipo,
            mascara: campo?.mascara
        });

        if (!this.shouldShowCampo(campo)) {
            console.log('[MASK-DEBUG][INLINE] hidden by shouldShowCampo', { slug: campo?.slug, id: campo?.id });
            return null;
        }

        // Renderizar campos posicionados ANTES deste campo (se mapaPosicoes foi fornecido)
        const camposAntes = mapaPosicoes && mapaPosicoes[campo.slug]?.before 
            ? mapaPosicoes[campo.slug].before.map(c => this.renderCampoPersonalizadoInline(c, programaAtual, mapaPosicoes))
            : null;

        // Renderizar campos posicionados DEPOIS deste campo (se mapaPosicoes foi fornecido)
        const camposDepois = mapaPosicoes && mapaPosicoes[campo.slug]?.after
            ? mapaPosicoes[campo.slug].after.map(c => this.renderCampoPersonalizadoInline(c, programaAtual, mapaPosicoes))
            : null;

        console.log('[MASK-DEBUG][INLINE] positioned children', {
            slug: campo?.slug,
            beforeCount: mapaPosicoes && mapaPosicoes[campo.slug]?.before ? mapaPosicoes[campo.slug].before.length : 0,
            afterCount: mapaPosicoes && mapaPosicoes[campo.slug]?.after ? mapaPosicoes[campo.slug].after.length : 0
        });


        // Caso especial: campo informativo
        if (campo.tipo === 'texto' && (campo.mascara || '').includes('information-field')) {
            return (
                <>
                    {camposAntes}
                    <Col sm={12} className="mb-3" key={`info_inline_${campo.id}`}>
                        <Alert variant="info" className="mb-0" role="status" aria-live="polite">
                            {campo.nome ? <div className="fw-semibold mb-1">{campo.nome}</div> : null}
                            <div>{campo.descricao}</div>
                        </Alert>
                    </Col>
                    {camposDepois}
                </>
            );
        }

        const rule = this.parseShowOnMask(campo.mascara || '');
        const minL = rule?.minLength || undefined;
        const maxL = rule?.maxLength || undefined;

        // Renderiza campo tipo arquivo
        if (campo.tipo === 'arquivo') {
            return (
                <>
                    {camposAntes}
                    <Col sm={6} className="mb-3" key={`arquivo_inline_${campo.id}`}>
                        <Form.Group>
                            <Form.Label>
                                {campo.nome}
                                {campo.obrigatorio && (
                                    <>
                                        <span className="text-danger ms-1" aria-hidden="true">*</span>
                                        <span className="visually-hidden"> obrigatório</span>
                                    </>
                                )}
                            </Form.Label>
                            <Form.Control 
                                type="file" 
                                required={campo.obrigatorio && !campo.arquivo}
                                onChange={(e) => this.handleChangeCampoPacienteExtra(campo.id, e)}
                            />
                            {campo.descricao && <Form.Text className="text-muted">{campo.descricao}</Form.Text>}
                        </Form.Group>
                        {campo.arquivo && (
                            <a
                                href={campo.arquivo}
                                target="_blank"
                                rel="noreferrer"
                                className="btn btn-link btn-sm p-0 mt-1"
                            >
                            Ver Arquivo
                            </a>
                        )}
                    </Col>
                    {camposDepois}
                </>
            );
        }

        // Renderiza outros tipos de campo
        if (campo.tipo === 'texto' || campo.tipo === 'area_texto' || campo.tipo === 'data' || 
            campo.tipo === 'selecao' || campo.tipo === 'radio' || campo.tipo === 'numero' || campo.tipo === 'checkbox') {
            
            return (
                <>
                    {camposAntes}
                    <Col sm={campo.tipo === 'area_texto' ? 12 : 6} className="mb-3" key={`campo_inline_${campo.id}`}>
                        <Form.Group>
                            <Form.Label>
                                {campo.nome}
                                {campo.obrigatorio && (
                                    <>
                                        <span className="text-danger ms-1" aria-hidden="true">*</span>
                                        <span className="visually-hidden"> obrigatório</span>
                                    </>
                                )}
                            </Form.Label>
                            {
                                (campo.tipo === 'selecao') ? (
                                    <Form.Control as="select" defaultValue={campo.valor || ''} required={campo.obrigatorio} onChange={(e) => this.handleChangeCampoPacienteExtra(campo.id, e.target.value)}>
                                        <option value="">Selecione...</option>
                                        {campo.opcoes.split('\n').map((opcao, idx) => {
                                            const [valor, label] = opcao.split(':');
                                            return <option key={idx} value={valor}>{label}</option>;
                                        })}
                                    </Form.Control>
                                ) : (campo.tipo === 'texto' && (campo.mascara || '').includes('mask-phone')) ? (
                                    <Form.Control
                                        as={IMaskInput}
                                        mask="(00) 00000-0000"
                                        defaultValue={campo.valor || ''}
                                        required={campo.obrigatorio}
                                        onAccept={(value) => this.handleChangeCampoPacienteExtra(campo.id, value)}
                                    />
                                ) : (campo.tipo === 'texto' || campo.tipo === 'data') ? (
                                    <Form.Control
                                        type={campo.tipo === 'data' ? 'date' : 'text'}
                                        defaultValue={campo.valor || ''}
                                        required={campo.obrigatorio}
                                        minLength={minL}
                                        maxLength={maxL}
                                        onChange={(e) => this.handleChangeCampoPacienteExtra(campo.id, e.target.value)}
                                    />
                                ) : (campo.tipo === 'numero') ? (
                                    <Form.Control
                                        type="number"
                                        value={this.state.valoresCamposExtraPaciente?.[campo.id] ?? (campo.valor || '')}
                                        required={campo.obrigatorio}
                                        onChange={(e) => this.handleChangeCampoPacienteExtra(campo.id, e)}
                                    />
                                ) : (campo.tipo === 'checkbox') ? (
                                    <div>
                                        {(campo.opcoes || '').split('\n').map((opcao, idx) => {
                                            const [valor, label] = opcao.split(':');
                                            return (
                                                <Form.Check
                                                    key={`checkbox_inline_${campo.id}_${idx}`}
                                                    type="checkbox"
                                                    label={label || valor}
                                                    value={valor}
                                                    checked={(this.state.valoresCamposExtraPaciente?.[campo.id] || '').split(',').includes(valor)}
                                                    onChange={(e) => this.handleChangeCampoPacienteExtra(campo.id, e)}
                                                />
                                            );
                                        })}
                                    </div>
                                ) : (campo.tipo === 'radio') ? (
                                    <div>
                                        {campo.opcoes.split('\n').map((opcao, indexO) => {
                                            const [valorRadioRaw, labelRadioRaw] = opcao.split(':');
                                            const valorRadio = (valorRadioRaw || '').trim();
                                            const labelRadio = (labelRadioRaw || valorRadio).trim();
                                            const valorAtual = (this.state.valoresCamposExtraPaciente?.[campo.id] ?? campo.valor ?? '').toString();
                                            
                                            return (
                                                <Form.Check 
                                                    inline 
                                                    type="radio" 
                                                    label={labelRadio} 
                                                    key={`radio_inline_${campo.id}_opcao_${indexO}`} 
                                                    id={`radio_inline_${campo.id}_opcao_${indexO}`}
                                                    value={valorRadio} 
                                                    onChange={(e) => this.handleChangeCampoPacienteExtra(campo.id, e.target.value)}
                                                    checked={valorAtual === valorRadio}
                                                />
                                            );
                                        })}
                                    </div>
                                ) : (
                                    <Form.Control
                                        as={campo.tipo === 'area_texto' ? 'textarea' : 'text'}
                                        defaultValue={campo.valor || ''}
                                        required={campo.obrigatorio}
                                        className={campo.tipo === 'area_texto' ? 'custom-textarea2' : ''}
                                        minLength={minL}
                                        maxLength={maxL}
                                        onChange={(e) => this.handleChangeCampoPacienteExtra(campo.id, e.target.value)}
                                    />
                                )
                            }
                            {campo.descricao && <Form.Text className="text-muted" style={{fontSize: '0.9em'}}>{campo.descricao}</Form.Text>}
                        </Form.Group>
                    </Col>
                    {camposDepois}
                </>
            );
        }

        return null;
    };


    handleChangeNovoEndereco = (e) => {
        const { name, value } = e.target;
        this.setState(prevState => ({
            novoEndereco: {
                ...prevState.novoEndereco,
                [name]: value
            }
        }));
    };

    handleCepNovoEndereco = (e) => {
        const cep = e.target.value;
        this.handleChangeNovoEndereco(e); 

        const cepLimpo = cep.replace(/\D/g, '');

        if (cepLimpo.length === 8) {
            this.setState({ loadingEnderecoExtra: true });
            axios.get(`https://viacep.com.br/ws/${cepLimpo}/json/`)
                .then(res => {
                    if (!res.data.erro) {
                        this.setState(prevState => ({
                            novoEndereco: {
                                ...prevState.novoEndereco,
                                endereco: res.data.logradouro,
                                complemento: res.data.complemento,
                                bairro: res.data.bairro,
                                cidade: res.data.localidade,
                                uf: res.data.uf
                            },
                            loadingEnderecoExtra: false
                        }));
                    } else {
                        this.setState({ loadingEnderecoExtra: false });
                    }
                })
                .catch(() => {
                    this.setState({ loadingEnderecoExtra: false });
                });
        }
        
        // Se não encontrou centro ou opção é 'outro', usa o endereço manual
        if (!payload) {
            payload = {
                ...novoEndereco,
                nome: 'Endereço de Entrega - Kit',
                beneficiario_id: beneficiario_id,
                endereco_principal: false,
                complemento: novoEndereco.complemento || ""
            };
        }

        return api.post('/enderecos/', payload);
    };

    salvarNovoEndereco = async (beneficiario_id) => {
        const { novoEndereco, enderecoKitOpcao, centrosReferencia } = this.state;
        
        let payload;
        
        // Verifica se foi selecionado um centro de referência
        if (enderecoKitOpcao !== 'outro') {
            const centroSelecionado = centrosReferencia.find(
                c => String(c.centro_referencia_id) === enderecoKitOpcao
            );
            
            if (centroSelecionado && centroSelecionado.dados_centro) {
                const enderecoCentro = centroSelecionado.dados_centro;
                payload = {
                    nome: `${enderecoCentro.nome || 'Centro de Referência'}`,
                    beneficiario_id: beneficiario_id,
                    endereco_principal: false,
                    cep: enderecoCentro.cep || '',
                    endereco: enderecoCentro.endereco || '',
                    numero: enderecoCentro.numero || '',
                    complemento: enderecoCentro.complemento || '',
                    bairro: enderecoCentro.bairro || '',
                    cidade: enderecoCentro.cidade || '',
                    uf: enderecoCentro.uf || '',
                    responsavel: enderecoCentro.responsavel_recebimento
                };
            }
        }
        
        // Se não encontrou centro ou opção é 'outro', usa o endereço manual
        if (!payload) {
            payload = {
                ...novoEndereco,
                nome: 'Endereço de Entrega - Kit',
                beneficiario_id: beneficiario_id,
                endereco_principal: false,
                complemento: novoEndereco.complemento || ""
            };
        }

        return api.post('/enderecos/', payload);
    };

    renderFormularioEnderecoExtra = () => {
        const { novoEndereco, centrosReferencia, loadingCentrosReferencia, enderecoKitOpcao } = this.state;

        return (
            <Card className="mt-3 border-warning">
                <Card.Header className="bg-warning text-dark">
                    <strong><FaStream className="me-2"/>Endereço para Envio do Kit (Obrigatório)</strong>
                </Card.Header>
                <Card.Body>
                    {loadingCentrosReferencia ? (
                        <div className="text-center py-3">
                            <span className="spinner-border spinner-border-sm me-2"></span>
                            Carregando opções de endereço...
                        </div>
                    ) : (
                        <>
                            {/* Se houver centros de referência, exibe as opções */}
                            {centrosReferencia.length > 0 && (
                                <div className="mb-4">
                                    <Form.Label className="fw-bold">Selecione o endereço para envio:</Form.Label>
                                    
                                    {centrosReferencia.map((centro) => {
                                        const endereco = centro.dados_centro || {};
                                        const enderecoFormatado = [
                                            endereco.endereco,
                                            endereco.numero,
                                            endereco.complemento,
                                            endereco.bairro,
                                            endereco.cidade,
                                            endereco.uf,
                                            endereco.cep
                                        ].filter(Boolean).join(', ');

                                        return (
                                            <Form.Check
                                                key={centro.centro_referencia_id}
                                                type="radio"
                                                id={`centro-${centro.centro_referencia_id}`}
                                                name="enderecoKitOpcao"
                                                className="mb-2 p-2 border rounded"
                                                style={{ 
                                                    backgroundColor: enderecoKitOpcao === String(centro.centro_referencia_id) ? '#fff3cd' : 'transparent'
                                                }}
                                                label={
                                                    <div>
                                                        <strong>{endereco.nome || 'Centro de Referência'}</strong>
                                                        <br />
                                                        <small className="text-muted">{enderecoFormatado}</small>
                                                        {endereco.responsavel_recebimento && (
                                                            <>
                                                                <br />
                                                                <small className="text-info">
                                                                    Responsável: {endereco.responsavel_recebimento}
                                                                    {endereco.telefone && ` - Tel: ${endereco.telefone}`}
                                                                </small>
                                                            </>
                                                        )}
                                                    </div>
                                                }
                                                value={String(centro.centro_referencia_id)}
                                                checked={enderecoKitOpcao === String(centro.centro_referencia_id)}
                                                onChange={(e) => this.setState({ enderecoKitOpcao: e.target.value })}
                                            />
                                        );
                                    })}
                                    
                                    {/* Opção para informar outro endereço */}
                                    <Form.Check
                                        type="radio"
                                        id="centro-outro"
                                        name="enderecoKitOpcao"
                                        className="mb-2 p-2 border rounded"
                                        style={{ 
                                            backgroundColor: enderecoKitOpcao === 'outro' ? '#fff3cd' : 'transparent'
                                        }}
                                        label={
                                            <div>
                                                <strong>Outro endereço</strong>
                                                <br />
                                                <small className="text-muted">Informar um endereço diferente para envio</small>
                                            </div>
                                        }
                                        value="outro"
                                        checked={enderecoKitOpcao === 'outro'}
                                        onChange={(e) => this.setState({ enderecoKitOpcao: e.target.value })}
                                    />
                                </div>
                            )}

                            {/* Formulário de endereço manual - só exibe se não houver centros OU se selecionou "outro" */}
                            {(centrosReferencia.length === 0 || enderecoKitOpcao === 'outro') && (
                                <>
                                    <p className="small text-muted mb-3">
                                        Preencha o endereço abaixo para o envio do material de coleta.
                                    </p>
                                    <Row>
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-2">
                                                <Form.Label>CEP <span className="text-danger">*</span></Form.Label>
                                                <Form.Control 
                                                    as={IMaskInput} 
                                                    mask="00000-000" 
                                                    name="cep" 
                                                    value={novoEndereco.cep} 
                                                    onChange={this.handleCepNovoEndereco} 
                                                    required={enderecoKitOpcao === 'outro'}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-2">
                                                <Form.Label>Endereço <span className="text-danger">*</span></Form.Label>
                                                <Form.Control 
                                                    type="text" 
                                                    name="endereco" 
                                                    value={novoEndereco.endereco} 
                                                    onChange={this.handleChangeNovoEndereco} 
                                                    required={enderecoKitOpcao === 'outro'}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col sm={2} xs={12}>
                                            <Form.Group className="mb-2">
                                                <Form.Label>Número <span className="text-danger">*</span></Form.Label>
                                                <Form.Control 
                                                    type="text" 
                                                    name="numero" 
                                                    value={novoEndereco.numero} 
                                                    onChange={this.handleChangeNovoEndereco} 
                                                    required={enderecoKitOpcao === 'outro'}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-2">
                                                <Form.Label>Bairro <span className="text-danger">*</span></Form.Label>
                                                <Form.Control 
                                                    type="text" 
                                                    name="bairro" 
                                                    value={novoEndereco.bairro} 
                                                    onChange={this.handleChangeNovoEndereco} 
                                                    required={enderecoKitOpcao === 'outro'}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-2">
                                                <Form.Label>Cidade <span className="text-danger">*</span></Form.Label>
                                                <Form.Control 
                                                    type="text" 
                                                    name="cidade" 
                                                    value={novoEndereco.cidade} 
                                                    onChange={this.handleChangeNovoEndereco} 
                                                    required={enderecoKitOpcao === 'outro'}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-2">
                                                <Form.Label>UF <span className="text-danger">*</span></Form.Label>
                                                <Form.Control 
                                                    as="select"
                                                    name="uf" 
                                                    value={novoEndereco.uf} 
                                                    onChange={this.handleChangeNovoEndereco} 
                                                    required={enderecoKitOpcao === 'outro'}
                                                >
                                                    <option value="">Selecione...</option>
                                                    {Object.entries(this.ufOptions).map(([sigla, nome]) => (
                                                        <option key={sigla} value={sigla}>{nome}</option>
                                                    ))}
                                                </Form.Control>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={12} xs={12}>
                                            <Form.Group className="mb-2">
                                                <Form.Label>Complemento</Form.Label>
                                                <Form.Control 
                                                    type="text" 
                                                    name="complemento" 
                                                    value={novoEndereco.complemento} 
                                                    onChange={this.handleChangeNovoEndereco} 
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                </>
                            )}
                        </>
                    )}
                </Card.Body>
            </Card>
        );
    };

    carregarEnderecoExtra = () => {
        const { paciente_id } = this.state;
        
        if (paciente_id) {
            api.get(`/enderecos/?beneficiario_id=${paciente_id}&nome=Endereço de Entrega - Kit`)
                .then(response => {
                    const lista = response.data.results || response.data;
                    
                    if (lista && lista.length > 0) {
                        const end = lista[0]; 
                        
                        this.setState({
                            novoEndereco: {
                                cep: end.cep || '',
                                endereco: end.endereco || '',
                                numero: end.numero || '',
                                complemento: end.complemento || '',
                                bairro: end.bairro || '',
                                cidade: end.cidade || '',
                                uf: end.uf || '',
                            },
                            enderecoExtraSalvo: true
                        });
                    }
                })
                .catch(error => {
                    console.error('Erro ao carregar endereço de entrega do kit:', error);
                });
        }
    };

    carregarCentrosReferencia = () => {
        const { medico_id } = this.state;
        
        if (medico_id) {
            this.setState({ loadingCentrosReferencia: true });
            
            api.get(`/centros_referencia/prestadores/?prestador_id=${medico_id}`)
                .then(response => {
                    const lista = response.data.results || response.data || [];
                    
                    this.setState({
                        centrosReferencia: lista,
                        loadingCentrosReferencia: false,
                        // Se houver centros, seleciona o primeiro por padrão
                        enderecoKitOpcao: lista.length > 0 ? String(lista[0].centro_referencia_id) : 'outro'
                    });
                })
                .catch(error => {
                    console.error('Erro ao carregar centros de referência:', error);
                    this.setState({ 
                        centrosReferencia: [],
                        loadingCentrosReferencia: false,
                        enderecoKitOpcao: 'outro'
                    });
                });
        }
    };

    render(){
        if (!hasPerm('add_beneficiarios')) {
            return <Navigate to='/sem-permissao' />
        }

        const currentDate = new Date().toISOString().split('T')[0];
        const minDate = new Date();
        minDate.setFullYear(minDate.getFullYear() - 120);
        const minDateString = minDate.toISOString().split('T')[0];

        let dados_usuario = getCurrentUser();

        const somenteDados = !!this.props.somenteDados; 

        //Verifica se habilita campo (desabilita em caso de cadastro de novo paciente quando é cadastro de novo paciente - pré cadastro)
        const habilitar_campo_pre_cadastro = (this.state.programa_dados.habilitar_pre_cadastro_basico && !this.state.paciente_id) ? false : true;

        const obrigatorioEmailPaciente = getConfig(
            this.state.programa_dados?.configuracoes,
            "validacoes.email_paciente_obrigatorio",
            true // fallback
        );

        const obrigatorioCelularPaciente = getConfig(
            this.state.programa_dados?.configuracoes,
            "validacoes.celular_paciente_obrigatorio",
            true // fallback
        );

        const obrigatorioNascimentoPaciente = getConfig(
            this.state.programa_dados?.configuracoes,
            "validacoes.nascimento_paciente_obrigatorio",
            false // fallback
        );

        const obrigatorioSexoPaciente = getConfig(
            this.state.programa_dados?.configuracoes,
            "validacoes.sexo_paciente_obrigatorio",
            false // fallback
        );

        const dadosCuidadorOpcional = getConfig(
            this.state.programa_dados?.configuracoes,
            "validacoes.dados_cuidador_opcional",
            false // fallback
        );

        // Caregiver requirement flags
        const reqParentescoCuidador = getConfig(this.state.programa_dados?.configuracoes, "validacoes.parentesco_cuidador_obrigatorio", !dadosCuidadorOpcional);
        const reqNomeCuidador = getConfig(this.state.programa_dados?.configuracoes, "validacoes.nome_cuidador_obrigatorio", !dadosCuidadorOpcional);
        const reqCPFCuidador = getConfig(this.state.programa_dados?.configuracoes, "validacoes.cpf_cuidador_obrigatorio", true);
        const reqEmailCuidador = getConfig(this.state.programa_dados?.configuracoes, "validacoes.email_cuidador_obrigatorio", true);
        const reqCelularCuidador = getConfig(this.state.programa_dados?.configuracoes, "validacoes.celular_cuidador_obrigatorio", !dadosCuidadorOpcional);
        const reqTelefoneCuidador = getConfig(this.state.programa_dados?.configuracoes, "validacoes.telefone_cuidador_obrigatorio", false);
        const reqNascimentoCuidador = getConfig(this.state.programa_dados?.configuracoes, "validacoes.nascimento_cuidador_obrigatorio", true);

        const exibirTelefonePreCadastro = getConfig(
            this.state.programa_dados?.configuracoes,
            "validacoes.exibir_telefone_pre_cadastro",
            false 
        );

        const exibirGeneroPreCadastro = getConfig(
            this.state.programa_dados?.configuracoes,
            "validacoes.exibir_genero_pre_cadastro",
            false 
        );

        const preferenciaContatoObrigatorio = getConfig(
            this.state.programa_dados?.configuracoes,
            "cadastro_paciente.preferencia_contato_obrigatorio",
            false 
        );

        const tituloAba = getConfig(this.state.programa_dados?.configuracoes, "cadastro_paciente.titulo_aba", 'Dados do Paciente');
        const permiteLoginBeneficiario = programaPermiteLoginBeneficiario(this.state.programa_dados);

        const programaAtual = (this.state.programa_id) ? this.state.programa_id : dados_usuario['ambiente_programa_id'];
        const camposPreparados = (this.state.pacientes_campos || []).map(campo => {
            const campoComValor = { ...campo };
            const valorItem = (this.state.extra_valores_list || []).find(v => v.campo_slug === campo.slug);
            if (valorItem) {
                campoComValor.valor = valorItem.valor;
                campoComValor.arquivo = valorItem.arquivo;
            }
            return campoComValor;
        });
        const { mapaPosicoes } = this.organizarCamposPorPosicao(camposPreparados);

        return (
            <div>
                {!somenteDados && (
                <Row className="align-items-center">
                    <Col sm={6} lg={6}>
                        <h4 className="page-title">{this.state.titulo_pagina}</h4>
                    </Col>
                </Row>
                )}
                <Tabs defaultActiveKey="dadosPaciente" id="tabs-servico" className="aditus-tabs">
                    <Tab eventKey="dadosPaciente" title={this.state.paciente_id ? 'Dados do Paciente' : tituloAba}>
                        <Card className="cardDestaque">
                            <Card.Body>                    
                                <Form onSubmit={this.enviaPaciente}>
                                    <h4>Dados do Paciente</h4>
                                    <Row>
                                        {dados_usuario['ambiente_cliente_id'] > 0 || somenteDados ? (
                                            <></>
                                            ) : (
                                            this.renderFieldWithPositionedFields('cliente_id', (
                                            <Col sm={6} xs={12}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Cliente <span className="text-danger">*</span></Form.Label>
                                                    <AsyncSelect
                                                        cacheOptions
                                                        loadOptions={this.carregarClientes}
                                                        defaultOptions
                                                        name="cliente_id"
                                                        onChange={e => this.handleChange(e, 'cliente_id')}
                                                        placeholder="Buscar cliente..."
                                                        noOptionsMessage={() => "Nenhum cliente encontrado"}
                                                        value={this.state.cliente_id ? { value: this.state.cliente_id, label: this.state.cliente_nome } : null}
                                                        isDisabled={!!this.state.cliente_id && !!this.state.paciente_id} // Desabilita o campo se cliente_id estiver presente
                                                    />
                                                    <Form.Text className="text-danger">{this.state.clienteIdHelper}</Form.Text>
                                                </Form.Group>
                                            </Col>
                                            ), mapaPosicoes, programaAtual)
                                        )}

                                        {this.state.cliente_id && dados_usuario['ambiente_cliente_id'] === '' && !somenteDados && (
                                            this.renderFieldWithPositionedFields('programa_id', (
                                            <Col sm={6} xs={12}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Programa <span className="text-danger">*</span></Form.Label>
                                                    <AsyncSelect
                                                        cacheOptions
                                                        loadOptions={(inputValue) => this.carregarProgramasCliente(inputValue, this.state.cliente_id)}
                                                        defaultOptions
                                                        name="programa_id"
                                                        placeholder="Buscar programa..."
                                                        noOptionsMessage={() => "Nenhum programa encontrado"}
                                                        onChange={e => this.handleChange(e, 'programa_id')}
                                                        isDisabled={!!this.state.programa_id && !!this.state.programa_id} // Desabilita o campo se programa_id estiver presente
                                                        value={this.state.programa_id ? { value: this.state.programa_id, label: this.state.programa_nome } : null}
                                                    />
                                                    <Form.Text className="text-danger">{this.state.programaIdHelper}</Form.Text>
                                                </Form.Group>
                                            </Col>
                                            ), mapaPosicoes, programaAtual)
                                        )}
                                    </Row>
                                    {(this.state.cliente_id && this.state.programa_id)  && (
                                        <>
                                            <Row>
                                                {this.renderFieldWithPositionedFields('cpf', (
                                                <Col sm={3} xs={12}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>CPF {this.state.exige_cpf_atendimento && <span className="text-danger">*</span>}</Form.Label>
                                                        <Form.Control
                                                            as={IMaskInput}
                                                            required={this.state.exige_cpf_atendimento}
                                                            mask="000.000.000-00"
                                                            placeholder="CPF"
                                                            disabled={this.state.cpf_nao_informado}
                                                            name="cpf"
                                                            id="formCpf"
                                                            value={this.state.cpf}
                                                            onChange={(e) => this.handleCpfChange(e.target.value)}
                                                            onPaste={this.handlePaste}
                                                        />
                                                        {!this.state.exige_cpf_atendimento && 
                                                            <Form.Check 
                                                                type="checkbox" 
                                                                label="CPF Não informado" 
                                                                name="cpf_nao_informado" 
                                                                checked={this.state.cpf_nao_informado} 
                                                                onChange={(e) => {
                                                                    this.setState({ 
                                                                        cpf_nao_informado: e.target.checked
                                                                    });
                                                                }}
                                                            />
                                                        }
                                                        <Form.Text id="formCpfHelpBlock" className="text-danger">{this.state.cpfHelper}</Form.Text>
                                                    </Form.Group>
                                                </Col>
                                                ), mapaPosicoes, programaAtual)}
                                                {(habilitar_campo_pre_cadastro || obrigatorioNascimentoPaciente) && (
                                                this.renderFieldWithPositionedFields('data_nascimento', (
                                                <Col sm={3} xs={12}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Data de Nascimento <span className="text-danger">*</span></Form.Label>
                                                        <Form.Control 
                                                            type="date" 
                                                            required 
                                                            placeholder="Data de Nascimento" 
                                                            name="data_nascimento" 
                                                            value={this.state.data_nascimento} 
                                                            onChange={this.handleChange} 
                                                            max={currentDate}
                                                            min={minDateString}
                                                        />                            
                                                        <Form.Text id="formDataNascimentoHelpBlock" className="text-danger">{this.state.dataNascimentoHelper}</Form.Text>
                                                        {this.state.data_nascimento && (
                                                            <p className="mb-0"><Form.Text className="text-info"><strong>Idade: {this.calcularIdade(this.state.data_nascimento)} anos</strong></Form.Text></p>
                                                        )}
                                                    </Form.Group>
                                                </Col>
                                                ), mapaPosicoes, programaAtual))}
                                                {this.renderFieldWithPositionedFields('nome', (
                                                <Col sm={6} xs={12}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Nome <span className="text-danger">*</span></Form.Label>
                                                        <Form.Control type="text" required placeholder="Nome" name="nome" value={this.state.nome} onChange={this.handleChange} />                            
                                                        <Form.Text id="formNomeHelpBlock" className="text-danger">{this.state.nomeHelper}</Form.Text>
                                                    </Form.Group>
                                                </Col>
                                                ), mapaPosicoes, programaAtual)}
                                                {(habilitar_campo_pre_cadastro || obrigatorioSexoPaciente) && (
                                                this.renderFieldWithPositionedFields('genero', (
                                                <Col sm={6} xs={12}>
                                                    <Form.Label>Gênero <span className="text-danger">*</span></Form.Label>
                                                    <div className="mb-3">
                                                    {
                                                        Object.keys(this.list_generos).map((key, index) => ( 
                                                        <Form.Check inline type="radio" required={(habilitar_campo_pre_cadastro || exibirGeneroPreCadastro)} label={this.list_generos[key]} key={key} id={key} name="genero" value={key} onChange={this.handleChange} checked={ key === this.state.genero ? true : false } />
                                                        ))
                                                    }                                              
                                                    </div>
                                                </Col>
                                                ), mapaPosicoes, programaAtual))}
                                                
                                                {this.renderFieldWithPositionedFields('email', (
                                                <Col sm={6} xs={12}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>E-mail {obrigatorioEmailPaciente && <span className="text-danger">*</span>}</Form.Label>
                                                        <Form.Control type="email" placeholder="E-mail" name="email" id="formEmail" value={this.state.email} onChange={this.handleChange} required={obrigatorioEmailPaciente} />                            
                                                        <Form.Text id="formEmailHelpBlock" className="text-danger">{this.state.emailHelper}</Form.Text>
                                                    </Form.Group>
                                                </Col>
                                                ), mapaPosicoes, programaAtual)}
                                                
                                                {(habilitar_campo_pre_cadastro || exibirTelefonePreCadastro) && (
                                                    this.renderFieldWithPositionedFields('telefone', (
                                                    <Col sm={3} xs={12}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Telefone</Form.Label>
                                                            <Form.Control as={IMaskInput} mask="(00) 00000-0000" placeholder="Telefone do paciente" name="telefone" id="formTelefone" value={this.state.telefone} onChange={this.handleChange} onPaste={this.handlePaste} />
                                                            <Form.Text id="formTelefoneHelpBlock" className="text-danger">{this.state.telefoneHelper}</Form.Text>
                                                        </Form.Group>
                                                    </Col>
                                                    ), mapaPosicoes, programaAtual)
                                                )}
                                                
                                                {this.renderFieldWithPositionedFields('celular', (
                                                <Col sm={3} xs={12}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Celular {obrigatorioCelularPaciente && <span className="text-danger">*</span>}</Form.Label>
                                                        <Form.Control as={IMaskInput} mask="(00) 00000-0000" required={obrigatorioCelularPaciente} placeholder="Celular do paciente" name="celular" id="formCelular" value={this.state.celular} onChange={this.handleChange} onPaste={this.handlePaste} />
                                                        <Form.Text id="formCelularHelpBlock" className="text-danger">{this.state.celularHelper}</Form.Text>
                                                    </Form.Group>
                                                </Col>
                                                ), mapaPosicoes, programaAtual)}
                                                
                                                {dados_usuario['tipo_usuario'] === '' && (
                                                    this.renderFieldWithPositionedFields('cadastro_teste', (
                                                    <Col sm={6} xs={12}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Cadastro Teste</Form.Label>
                                                            <div>
                                                                <Button 
                                                                    variant={this.state.cadastro_teste ? "success" : "outline-secondary"}
                                                                    onClick={() => this.setState({ cadastro_teste: true })}>
                                                                    Sim
                                                                </Button>
                                                                {' '}
                                                                <Button 
                                                                    variant={!this.state.cadastro_teste ? "danger" : "outline-secondary"}
                                                                    onClick={() => this.setState({ cadastro_teste: false })}>
                                                                    Não
                                                                </Button>
                                                            </div>
                                                        </Form.Group>
                                                    </Col>
                                                    ), mapaPosicoes, programaAtual)
                                                )}
                                                {((this.state.doenca_id && this.state.doenca_nome) || (this.state.programa_dados.doenca_principal_id && this.state.programa_dados.doenca_principal_id > 0)) && this.state.programa_dados.exige_confirmacao_diagnostico && (
                                                    habilitar_campo_pre_cadastro && (
                                                        <Col sm={12} xs={12}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>
                                                                    Confirmo que o paciente foi diagnosticado com {
                                                                        this.state.doenca_nome === 'Glioma Difuso do Tipo Adulto Grau 2'
                                                                        ? 'glioma grau 2 do tipo adulto, sem indicação imediata de quimioterapia ou radioterapia'
                                                                        : (this.state.doenca_nome || this.state.programa_dados?.dados_doenca_principal?.nome || '')
                                                                    }
                                                                </Form.Label>
                                                                <div>
                                                                    <Button 
                                                                        variant={this.state.confirmacao_diagnostico ? "success" : "outline-secondary"}
                                                                        onClick={() => this.setState({ confirmacao_diagnostico: true })}>
                                                                        Sim
                                                                    </Button>
                                                                    {' '}
                                                                    <Button 
                                                                        variant={!this.state.confirmacao_diagnostico ? "danger" : "outline-secondary"}
                                                                        onClick={() => this.setState({ confirmacao_diagnostico: false })}>
                                                                        Não
                                                                    </Button>
                                                                </div>
                                                            </Form.Group>
                                                        </Col>
                                                    )
                                                )} 
                                                {/*}
                                                <Col sm={6} xs={12}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Plano de Saúde</Form.Label>
                                                        <Form.Control type="text" placeholder="Plano de Saúde" name="plano_saude" value={this.state.plano_saude} onChange={this.handleChange} />     
                                                    </Form.Group>
                                                </Col>
                                                <Col sm={6} xs={12}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Número da Carteirinha</Form.Label>
                                                        <Form.Control type="text" placeholder="Número da Carteirinha" name="numero_carteirinha" value={this.state.numero_carteirinha} onChange={this.handleChange} />     
                                                    </Form.Group>
                                                </Col>*/}   
                                            </Row>
                                            {habilitar_campo_pre_cadastro && (
                                                <Row>
                                                    <Col sm={6} xs={12} className="d-none">
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Plano do Programa</Form.Label>
                                                            <AsyncSelect
                                                                cacheOptions
                                                                loadOptions={this.carregarPlanos}
                                                                defaultOptions
                                                                name="plano_id"
                                                                onChange={e => this.handleChange(e, 'plano_id')}
                                                                placeholder="Buscar plano..."
                                                                noOptionsMessage={() => "Nenhum plano encontrado"}
                                                                value={this.state.plano_id ? { value: this.state.plano_id, label: this.state.plano_nome } : null}
                                                                isDisabled={!!this.state.cliente_id && !!this.state.paciente_id} // Desabilita o campo se cliente_id estiver presente
                                                            />
                                                            <Form.Text className="text-danger">{this.state.planoIdHelper}</Form.Text>
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                            )}
                                            
                                            <Row>
                                                <h4 className="mt-3">{this.state.programa_dados.label_endereco_paciente || 'Endereço'}</h4>
                                                <Col sm={12} xs={12}>
                                                    <Row>    
                                                        {!this.state.programa_dados.ocultar_nome_local && (
                                                        habilitar_campo_pre_cadastro && (
                                                            this.renderFieldWithPositionedFields('nome_local', (
                                                            <Col sm={6} xs={12}>
                                                                <Form.Group className="mb-3">
                                                                    <Form.Label>Nome do Local {this.state.programa_dados.endereco_paciente_obrigatorio ? <span className="text-danger">*</span> : ''}</Form.Label>
                                                                    <Form.Control type="text" required={this.state.programa_dados.endereco_paciente_obrigatorio} placeholder="Nome do Local" name="nome_local" value={this.state.nome_local} onChange={this.handleChange} />
                                                                    <Form.Text id="formNomeLocalHelpBlock" className="text-danger">{this.state.nomeLocalHelper}</Form.Text>
                                                                </Form.Group>
                                                            </Col>
                                                            ), mapaPosicoes, programaAtual)  
                                                        ))}                      
                                                     
                                                            <>
                                                                {this.renderFieldWithPositionedFields('cep', (
                                                                <Col sm={6} xs={12}>
                                                                    <Form.Group className="mb-3">
                                                                        <Form.Label>CEP {this.state.programa_dados.endereco_paciente_obrigatorio ? <span className="text-danger">*</span> : ''}</Form.Label>
                                                                        <Form.Control as={IMaskInput} required={this.state.programa_dados.endereco_paciente_obrigatorio} mask="00000-000" name="cep" type="text" placeholder="CEP" value={this.state.cep} onChange={this.onChangeCep} onPaste={this.handlePasteCep} />
                                                                        <Form.Text id="formCEPHelpBlock" className="text-danger">{this.state.cepHelper}</Form.Text>
                                                                    </Form.Group>
                                                                </Col>
                                                                ), mapaPosicoes, programaAtual)}
                                                                {this.renderFieldWithPositionedFields('endereco', (
                                                                <Col sm={6} xs={12}>
                                                                    <Form.Group className="mb-3">
                                                                        <Form.Label>Endereço {this.state.programa_dados.endereco_paciente_obrigatorio ? <span className="text-danger">*</span> : ''}</Form.Label>
                                                                        <Form.Control type="text" required={this.state.programa_dados.endereco_paciente_obrigatorio} placeholder="Endereço" name="endereco" value={this.state.endereco} onChange={this.handleChange} />
                                                                        <Form.Text id="formEnderecoHelpBlock" className="text-danger">{this.state.enderecoHelper}</Form.Text>
                                                                    </Form.Group>
                                                                </Col>
                                                                ), mapaPosicoes, programaAtual)}
                                                                {this.renderFieldWithPositionedFields('numero', (
                                                                <Col sm={6} xs={12}>
                                                                    <Form.Group className="mb-3">
                                                                        <Form.Label>Número {this.state.programa_dados.endereco_paciente_obrigatorio ? <span className="text-danger">*</span> : ''}</Form.Label>
                                                                        <Form.Control type="text" required={this.state.programa_dados.endereco_paciente_obrigatorio} placeholder="Número" name="numero" value={this.state.numero} onChange={this.handleChange} />
                                                                        <Form.Text id="formNumeroHelpBlock" className="text-danger">{this.state.numeroHelper}</Form.Text>
                                                                    </Form.Group>
                                                                </Col>
                                                                ), mapaPosicoes, programaAtual)}
                                                                </>
                                                        
                                                        
                                                            {this.renderFieldWithPositionedFields('complemento', (
                                                            <Col sm={6} xs={12}>
                                                                <Form.Group className="mb-3">
                                                                    <Form.Label>Complemento</Form.Label>
                                                                    <Form.Control type="text" placeholder="Complemento" name="complemento" value={this.state.complemento} onChange={this.handleChange} />
                                                                </Form.Group>
                                                            </Col>
                                                            ), mapaPosicoes, programaAtual)}
                                                        
                                                        {this.renderFieldWithPositionedFields('bairro', (
                                                        <Col sm={6} xs={12}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Bairro {this.state.programa_dados.endereco_paciente_obrigatorio ? <span className="text-danger">*</span> : ''}</Form.Label>
                                                                <Form.Control type="text" required={this.state.programa_dados.endereco_paciente_obrigatorio} placeholder="Bairro" name="bairro" value={this.state.bairro} onChange={this.handleChange} />
                                                                <Form.Text id="formBairroHelpBlock" className="text-danger">{this.state.bairroHelper}</Form.Text>
                                                            </Form.Group>
                                                        </Col>
                                                        ), mapaPosicoes, programaAtual)}
                                                     
                                                        {this.renderFieldWithPositionedFields('cidade', (
                                                        <Col sm={6} xs={12}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Cidade {this.state.programa_dados.endereco_paciente_obrigatorio ? <span className="text-danger">*</span> : ''}</Form.Label>
                                                                <Form.Control type="text" required={this.state.programa_dados.endereco_paciente_obrigatorio} placeholder="Cidade" name="cidade" value={this.state.cidade} onChange={this.handleChange} />
                                                                <Form.Text id="formCidadeHelpBlock" className="text-danger">{this.state.cidadeHelper}</Form.Text>
                                                            </Form.Group>
                                                        </Col>
                                                        ), mapaPosicoes, programaAtual)}
                                                        {this.renderFieldWithPositionedFields('uf', (
                                                        <Col sm={6} xs={12}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>UF {this.state.programa_dados.endereco_paciente_obrigatorio ? <span className="text-danger">*</span> : ''}</Form.Label>
                                                                <Form.Control as="select" value={this.state.uf} name="uf" required={this.state.programa_dados.endereco_paciente_obrigatorio} onChange={this.handleChange}>
                                                                    <option value="">Selecione o Estado</option>
                                                                    {Object.entries(this.ufOptions).map(([sigla, nome]) => (
                                                                        <option key={sigla} value={sigla}>{nome}</option>
                                                                    ))}
                                                                </Form.Control>
                                                                <Form.Text id="formUFHelpBlock" className="text-danger">{this.state.ufHelper}</Form.Text>
                                                            </Form.Group>
                                                        </Col>
                                                        ), mapaPosicoes, programaAtual)}
                                                    
                                                        {!this.state.programa_dados.ocultar_nome_local && !getConfig(this.state.programa_dados.configuracoes, 'cadastro_paciente.ocultar_telefone_contato', false) && (
                                                            habilitar_campo_pre_cadastro && (
                                                            this.renderFieldWithPositionedFields('endereco_telefone', (
                                                            <Col sm={6} xs={12}>
                                                                <Form.Group className="mb-3">
                                                                    <Form.Label>Telefone de Contato</Form.Label>
                                                                    <Form.Control as={IMaskInput} mask="(00) 00000-0000" placeholder="Telefone de contato" name="endereco_telefone" id="formEnderecoTelefone" value={this.state.endereco_telefone} onChange={this.handleChange}  onPaste={this.handlePaste} />
                                                                    <Form.Text id="formEnderecoTelefoneHelpBlock" className="text-danger">{this.state.enderecoTelefoneHelper}</Form.Text>
                                                                </Form.Group>
                                                            </Col>
                                                            ), mapaPosicoes, programaAtual)
                                                            )
                                                        )}
                                                    </Row>                                    
                                                </Col>
                                            </Row>  
                                            
                                            {habilitar_campo_pre_cadastro && (
                                                <Row>
                                                    {this.renderFieldWithPositionedFields('aceita_receber_whatsapp',
                                                        this.renderFieldWithPositionedFields('aceita_receber_emails',
                                                            this.renderFieldWithPositionedFields('aceita_receber_ligacoes', (
                                                    <Col sm={12} xs={12}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Preferência de Canal de Contato {preferenciaContatoObrigatorio ? <span className="text-danger">*</span> : ''}</Form.Label>
                                                            <Row>
                                                                <Col>
                                                                    <Form.Check 
                                                                        type="checkbox"
                                                                        label="Whatsapp"
                                                                        name="aceita_receber_whatsapp"
                                                                        checked={this.state.aceita_receber_whatsapp}
                                                                        onChange={(e) => this.setState({ aceita_receber_whatsapp: e.target.checked })}
                                                                        required={preferenciaContatoObrigatorio && !this.state.aceita_receber_whatsapp && !this.state.aceita_receber_emails && !this.state.aceita_receber_ligacoes}
                                                                    />
                                                                    <Form.Check 
                                                                        type="checkbox"
                                                                        label="E-mail"
                                                                        name="aceita_receber_emails"
                                                                        checked={this.state.aceita_receber_emails}
                                                                        onChange={(e) => this.setState({ aceita_receber_emails: e.target.checked })}
                                                                        required={preferenciaContatoObrigatorio && !this.state.aceita_receber_whatsapp && !this.state.aceita_receber_emails && !this.state.aceita_receber_ligacoes}
                                                                    />
                                                                    <Form.Check 
                                                                        type="checkbox"
                                                                        label="Telefone"
                                                                        name="aceita_receber_ligacoes"
                                                                        checked={this.state.aceita_receber_ligacoes}
                                                                        onChange={(e) => this.setState({ aceita_receber_ligacoes: e.target.checked })}
                                                                        required={preferenciaContatoObrigatorio && !this.state.aceita_receber_whatsapp && !this.state.aceita_receber_emails && !this.state.aceita_receber_ligacoes}
                                                                    />
                                                                </Col>
                                                            </Row>
                                                        </Form.Group>
                                                    </Col>
                                                            ), mapaPosicoes, programaAtual),
                                                        mapaPosicoes, programaAtual),
                                                    mapaPosicoes, programaAtual)}
                                                </Row>  
                                            )}
                                            <h4 className="mt-3">{getConfig(this.state.programa_dados.configuracoes,'cadastro_paciente.label_responsavel_legal', 'Possui Representante Legal ou Cuidador?')}</h4>
                                            <div>
                                                <Button 
                                                    variant={this.state.vinculo_cuidador ? "success" : "outline-secondary"}
                                                    onClick={() => this.setState({ vinculo_cuidador: true })}>
                                                    Sim
                                                </Button>
                                                {' '}
                                                <Button 
                                                    variant={!this.state.vinculo_cuidador ? "danger" : "outline-secondary"}
                                                    onClick={() => this.setState({ vinculo_cuidador: false, cuidador_documento_file: null })}>
                                                    Não
                                                </Button>
                                            </div>
                                            {
                                                this.state.vinculo_cuidador ? 
                                                (() => {
                                                    return (
                                                        <Row className="mt-3"> 
                                                            {this.renderFieldWithPositionedFields('tipo_cuidador', (
                                                                <Col sm={6} xs={12}>
                                                                    <Form.Group className="mb-3">
                                                                        <Form.Label>Parentesco do cuidador {reqParentescoCuidador && <span className="text-danger">*</span>}</Form.Label>
                                                                        <Form.Control as="select" required={reqParentescoCuidador}  name="tipo_cuidador" value={this.state.tipo_cuidador} onChange={this.handleChange}>
                                                                            <option value="" key="selecione">Selecione...</option>
                                                                            {
                                                                            Object.keys(this.list_tipos_cuidadores).map((key, index) => ( 
                                                                                <option value={key} key={key}>{this.list_tipos_cuidadores[key]}</option>
                                                                            ))
                                                                            }
                                                                        </Form.Control>      
                                                                        <Form.Text id="helperTipoCuidador" className="text-danger">{this.state.tipoCuidadorHelper}</Form.Text>
                                                                    </Form.Group>
                                                                </Col>
                                                            ), mapaPosicoes, programaAtual)}
                                                            
                                                            {this.renderFieldWithPositionedFields('cuidador_nome', (
                                                                <Col sm={6} xs={12}>
                                                                    <Form.Group className="mb-3">
                                                                        <Form.Label>Nome do cuidador {reqNomeCuidador && <span className="text-danger">*</span>}</Form.Label>
                                                                        <Form.Control type="text" required={reqNomeCuidador} name="cuidador_nome" value={this.state.cuidador_nome} onChange={this.handleChange} />                            
                                                                        <Form.Text id="helperCuidadorNome" className="text-danger">{this.cuidadorNomeHelper}</Form.Text>
                                                                    </Form.Group>
                                                                </Col>
                                                            ), mapaPosicoes, programaAtual)}
                                                            
                                                            {this.renderFieldWithPositionedFields('cuidador_cpf', (
                                                                <Col sm={6} xs={12}>
                                                                    <Form.Group className="mb-3">
                                                                        <Form.Label>CPF do cuidador {reqCPFCuidador && <span className="text-danger">*</span>}</Form.Label>
                                                                        <Form.Control as={IMaskInput} required={reqCPFCuidador} mask="000.000.000-00" name="cuidador_cpf" value={this.state.cuidador_cpf} onChange={this.handleChange} onPaste={this.handlePaste} />
                                                                        <Form.Text id="helperCuidadorCPF" className="text-danger">{this.state.cuidadorCpfHelper}</Form.Text>
                                                                    </Form.Group>
                                                                </Col>
                                                            ), mapaPosicoes, programaAtual)}
                                                            
                                                            <Col sm={6} xs={12}>
                                                                <Form.Group className="mb-3">
                                                                    <Form.Label>E-mail do cuidador {reqEmailCuidador && <span className="text-danger">*</span>}</Form.Label>
                                                                    <Form.Control type="email" required={reqEmailCuidador} name="cuidador_email" value={this.state.cuidador_email} onChange={this.handleChange} />                            
                                                                    <Form.Text id="helperCuidadorEmail" className="text-danger">{this.state.cuidadorEmailHelper}</Form.Text>
                                                                </Form.Group>
                                                            </Col>
                                                            <Col sm={6} xs={12}>
                                                                <Form.Group className="mb-3">
                                                                    <Form.Label>Celular do cuidador {reqCelularCuidador && <span className="text-danger">*</span>}</Form.Label>
                                                                    <Form.Control as={IMaskInput} required={reqCelularCuidador} mask="(00) 00000-0000" name="cuidador_celular" value={this.state.cuidador_celular} onChange={this.handleChange}  onPaste={this.handlePaste} />
                                                                    <Form.Text id="helperCuidadorCelular" className="text-danger">{this.state.cuidadorCelularHelper}</Form.Text>
                                                                </Form.Group>
                                                            </Col>
                                                            {habilitar_campo_pre_cadastro && (
                                                            <Col sm={6} xs={12}>
                                                                <Form.Group className="mb-3">
                                                                    <Form.Label>Telefone do cuidador {reqTelefoneCuidador && <span className="text-danger">*</span>}</Form.Label>
                                                                    <Form.Control as={IMaskInput} required={reqTelefoneCuidador} mask="(00) 00000-0000" name="cuidador_telefone" value={this.state.cuidador_telefone} onChange={this.handleChange}  onPaste={this.handlePaste} />
                                                                    <Form.Text id="helperCuidadorTelefone" className="text-danger">{this.state.cuidadorTelefoneHelper}</Form.Text>
                                                                </Form.Group>
                                                            </Col>
                                                            )}
                                                            
                                                            <Col sm={6} xs={12}>
                                                                <Form.Group className="mb-3">
                                                                    <Form.Label>Data de nascimento do cuidador {reqNascimentoCuidador && <span className="text-danger">*</span>}</Form.Label>
                                                                    <Form.Control 
                                                                        type="date" 
                                                                        name="cuidador_data_nascimento" 
                                                                        value={this.state.cuidador_data_nascimento} 
                                                                        onChange={this.handleChange} 
                                                                        max={currentDate}
                                                                        min={minDateString}
                                                                        required={reqNascimentoCuidador}
                                                                    />    
                                                                    <Form.Text id="helperCuidadorDataNascimento" className="text-danger">{this.state.cuidadorDataNascimentoHelper}</Form.Text>
                                                                </Form.Group>
                                                            </Col>
                                                            
                                                            {habilitar_campo_pre_cadastro && (
                                                            <Col sm={6} xs={12} className="d-none">
                                                                <Form.Group className="mb-3">
                                                                    <Form.Label>Endereço do cuidador</Form.Label>
                                                                    <Form.Control type="text" name="cuidador_endereco" value={this.state.cuidador_endereco} onChange={this.handleChange} />                            
                                                                    <Form.Text id="helperCuidadorEndereco" className="text-danger">{this.cuidadorEnderecoHelper}</Form.Text>
                                                                </Form.Group>
                                                            </Col>
                                                            )}
                                                        </Row>
                                                    );
                                                })() : ''
                                            }

                                            {getConfig(this.state.programa_dados?.configuracoes, 'pre_cadastro.endereco_kit', false) === true && !this.state.paciente_id && (
                                                this.renderFormularioEnderecoExtra()
                                            )}
                                                

                                            <div className="mt-4">
                                            {
                                                //campos extra do beneficiario
                                                this.renderizaCamposExtraBeneficiario()                                                    
                                            }
                                            </div>

                                            {this.state.erroLoadPaciente ? 
                                            <Alert variant="warning">
                                                {this.state.erroLoadPaciente}
                                            </Alert> : ''
                                            }                                      
                                            <Button variant="success" type="submit" className="btn-submit mt-5" disabled={this.state.loading}>
                                                {this.state.loading ? (
                                                    <span className="spinner-border spinner-border-sm"></span>
                                                ) : (
                                                    <>
                                                        <FaCheck className="me-1" /> Salvar
                                                    </>
                                                )}
                                            </Button>
                                        </>
                                    )}
                                </Form> 
                            </Card.Body>                
                        </Card>
                    </Tab>
                    {this.state.paciente_id && !somenteDados && (dados_usuario['tipo_usuario'] == '' || dados_usuario['tipo_usuario'] == 'operador') && permiteLoginBeneficiario && (
                        <Tab eventKey="acessoPaciente" title="Acesso">
                            <PacienteAcesso
                                beneficiarioId={this.state.paciente_id}
                                programaId={this.state.programa_id}
                                patientName={this.state.nome}
                                patientEmail={this.state.email}
                                patientCpf={this.state.cpf}
                            />
                        </Tab>
                    )}
                    {this.state.paciente_id && !somenteDados && dados_usuario['tipo_usuario'] == '' && (
                        <Tab eventKey="doencasPaciente" title="Hipótese Diagnóstica">
                            <Card className="cardDestaque">
                                <Card.Body>                    
                                    <Form onSubmit={this.enviaDoencaPaciente}>
                                        <h4>Hipótese Diagnóstica</h4>
                                        {this.state.doencas.map((doenca, index) => (
                                            <div key={index} className="row-list">
                                                <Row>
                                                    <Col sm={6}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Doença <span className="text-danger">*</span></Form.Label>
                                                            <AsyncSelect
                                                                cacheOptions
                                                                loadOptions={this.carregarDoencas}
                                                                defaultOptions
                                                                name="doenca_id"
                                                                placeholder="Buscar doença..."
                                                                noOptionsMessage={() => "Nenhuma doença encontrada"}
                                                                onChange={e => this.handleDoencaChange(index, e, 'doenca_id')}
                                                                value={doenca.doenca_id ? { value: doenca.doenca_id, label: doenca.doenca_nome } : null}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                                <Button variant="success" className="btn-sm" onClick={() => this.salvarDoenca(index)}><FaCheck className="me-1" /> Salvar Doença</Button>&nbsp;&nbsp;
                                                <Button variant="danger" className="btn-sm ml-3" onClick={() => this.removerDoenca(index)}><FaTimes className="me-1" /> Remover Doença</Button>
                                                <hr />
                                            </div>
                                        ))}
                                        <Button variant="secondary" onClick={this.adicionarDoenca}><FaStream /> Adicionar Doença</Button>
                                    </Form> 
                                </Card.Body>                
                            </Card>
                        </Tab>
                    )}
                    {this.state.paciente_id && !somenteDados && dados_usuario['tipo_usuario'] == '' && (
                        <Tab eventKey="medicosPaciente" title="Médicos Vinculados">
                            <Card className="cardDestaque">
                                <Card.Body>                    
                                    <Form onSubmit={this.enviaDoencaPaciente}>
                                        <h4>Médicos do Paciente</h4>
                                        {this.state.medicos.map((medico, index) => (
                                            <div key={index} className="row-list">
                                                <Row>
                                                    <Col sm={6}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Médico</Form.Label>
                                                            <AsyncSelect
                                                                cacheOptions
                                                                loadOptions={this.carregarMedicos}
                                                                defaultOptions
                                                                name="prestador_id"
                                                                placeholder="Buscar médico..."
                                                                noOptionsMessage={() => "Nenhum médico encontrado"}
                                                                onChange={e => this.handleMedicoChange(index, e, 'prestador_id')}
                                                                value={medico.prestador_id ? { value: medico.prestador_id, label: medico.prestador_nome } : null}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                                <Button variant="success" className="btn-sm" onClick={() => this.salvarMedico(index)}><FaCheck className="me-1" /> Salvar Médico</Button>&nbsp;&nbsp;
                                                <Button variant="danger" className="btn-sm ml-3" onClick={() => this.removerMedico(index)}><FaTimes className="me-1" /> Remover Médico</Button>
                                                <hr />
                                            </div>
                                        ))}
                                        <Button variant="secondary" onClick={this.adicionarMedico}><FaStream /> Adicionar Médico</Button>
                                    </Form> 
                                </Card.Body>                
                            </Card>
                        </Tab>
                    )}
                </Tabs>
                {this.renderHistoricoModal()}
            </div>
        )
    }
    
}

    
export default withRouter(PacientesEdit)
    
